import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/muuri_styles.css";
import "../styles/add_pane.css";
import "../styles/modal.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import PropTypes from "prop-types";
import _ from "lodash";
import config from "../config.js";
import axios from "axios";

function DropDownModal(props) {
  const [settingsVisibility, setSettingsVisibility] = useState({
    gauge: false,
    bar_chart: false,
    realtime_chart: false,
    fluid_tank: false,
    custom_gauge: false,
    equilizer_bar: false,
    mqtt_writer: false,
    mqtt_indicator: false,
    realtime_table: false,
    text_widget: false,
    dynamic_text_widget: false,
    // custom_form_widget: false,
    push_button: false,
    switch_button: false,
    editable_table_widget: false,
    access_list_widget: false,
    map_widget: false,
    nested_pane: false,
    image_widget: false,
  });

  const [chartArr, setChartArr] = useState([1]);
  const [sourceCount, setSourceCount] = useState(1);
  const [mapDeviceSourceCount, setMapDeviceSourceCount] = useState(1);
  const [numberOfColumn, setNumberOfColumn] = useState(1);
  const [numberOfStatuses, setNumberOfStatuses] = useState(0);
  const [numberOfInputFields, setNumberOfInputFields] = useState(0);
  const [statusPairs, setStatusPairs] = useState([{ key: "", value: "" }]);
  const [customFormInputFields, setCustomFormInputFields] = useState({});
  const [imageFile, setImageFile] = useState(null);
  const [numberOfBars, setNumberOfBars] = useState(5);
  const [availableAccessItems, setAvailableAccessItems] = useState([]); // Data fetched from API
  const [selectedAccessItems, setSelectedAccessItems] = useState(
    props.widget?.datasets?.[0]?.selectedAccessItems || []
  ); // Items user selects
  const [geofenceType, setGeofenceType] = useState(
    props?.editWidgetModal
      ? props.widget?.datasets?.[0]?.geofence?.type || "circle"
      : "circle"
  );
  const [enableDropdown, setEnableDropdown] = useState(
    props?.editWidgetModal
      ? props.widget?.datasets?.[0]?.enableExtraDropdown ?? false
      : false
  );

  const [extraOptions, setExtraOptions] = useState(
    props?.editWidgetModal
      ? props.widget?.datasets?.[0]?.extraOptions ?? []
      : []
  );

  const [newOption, setNewOption] = useState("");
  useEffect(() => {
    if (props.editWidgetModal && props.widget?.widget_type) {
      const event = { target: { value: props.widget.widget_type } };
      onChangeWidget(event);

      if (props.widget.widget_type === "equilizer_bar") {
        const dataset = props.widget.datasets?.[0] || {};
        const sourceCnt =
          dataset.sourceCnt || props.widget.datasets?.length || 1;
        setSourceCount(sourceCnt);
      }
      if (props.widget.widget_type === "map_widget") {
        const dataset = props.widget.datasets?.[0] || {};
        const deviceCount =
          dataset.sourceCnt || props.widget.datasets?.length || 1;
        setMapDeviceSourceCount(deviceCount);
      }
      if (
        props.widget.widget_type === "realtime_table" &&
        props.widget.columns
      ) {
        setNumberOfColumn(props.widget.columns);
      }
      if (
        props.widget.widget_type === "realtime_chart" &&
        props.widget.datasets?.length
      ) {
        setChartArr(Array(props.widget.datasets.length).fill(1));
      }
      if (
        props.widget.widget_type === "dynamic_text_widget" &&
        props.widget.datasets?.[0]?.statusPairs
      ) {
        setNumberOfStatuses(props.widget.datasets[0].statusPairs.length);
        setStatusPairs(props.widget.datasets[0].statusPairs);
      }
      // if (
      //   props.widget.widget_type === "custom_form_widget" &&
      //   props.widget.datasets?.[0]?.numberOfInputFields
      // ) {
      //   setNumberOfInputFields(props.widget.datasets[0].numberOfInputFields);
      //   setCustomFormInputFields(props.widget.datasets[0].customFormInputs || {});
      // }
      if (
        props.widget.widget_type === "editable_table_widget" &&
        props.widget.datasets?.[0]?.numberOfInputFields
      ) {
        setNumberOfInputFields(props.widget.datasets[0].numberOfInputFields);
        setCustomFormInputFields(
          props.widget.datasets[0].customFormInputs || {}
        );
      }

      if (
        props.widget.widget_type === "image_widget" &&
        props.widget.imageData
      ) {
        setImageFile(props.widget.imageData);
      }
      if (
        props.widget.widget_type === "bar_chart" &&
        props.widget.numberOfBars
      ) {
        setNumberOfBars(props.widget.numberOfBars);
      }
    }
  }, [props.editWidgetModal, props.widget]);

  const handleSourceCountChange = (value) =>
    setSourceCount(Math.max(1, Math.min(5, parseInt(value) || 1)));

  const handleDeviceSourceCountChange = (value) =>
    setMapDeviceSourceCount(Math.max(1, Math.min(10, parseInt(value) || 1)));


  const handleNumberOfColumns = (value) =>
    setNumberOfColumn(Math.max(1, parseInt(value) || 1));

  const handleNumberOfBarsChange = (value) =>
    setNumberOfBars(Math.max(1, Math.min(10, parseInt(value) || 5)));

  const handleNumberOfStatusesChange = (e) => {
    const count = Math.max(0, parseInt(e.target.value) || 0);
    const maxStatuses = 100;
    if (count <= maxStatuses) {
      setNumberOfStatuses(count);
      setStatusPairs((prev) =>
        Array(count)
          .fill()
          .map((_, i) => prev[i] || { key: "", value: "" })
      );
    } else {
      alert(`Maximum allowed statuses is ${maxStatuses}.`);
      setNumberOfStatuses(maxStatuses);
      setStatusPairs((prev) =>
        Array(maxStatuses)
          .fill()
          .map((_, i) => prev[i] || { key: "", value: "" })
      );
    }
  };

  const handleStatusPairChange = (index, type, value) => {
    setStatusPairs((prev) => {
      const newPairs = [...prev];
      newPairs[index][type] = value;
      return newPairs;
    });
  };

  const handleAccessChange = (e) => {
    const selectedIds = Array.from(
      e.target.selectedOptions,
      (option) => option.value
    );
    const updatedSelection = availableAccessItems.filter((item) =>
      selectedIds.includes(String(item.id))
    );
    setSelectedAccessItems(updatedSelection);
  };

  const fetchAvailableAccessItems = async () => {
    try {
      const res = await axios.post(
        `${config.BACKEND_URL}/widgets/view-table-data`,
        {
          host: props.widget?.datasets?.[0]?.host,
          port: props.widget?.datasets?.[0]?.port,
          topic: props.widget?.datasets?.[0]?.topic,
        }
      );
      const fetchedItems = res.data.allData || [];

      setAvailableAccessItems(fetchedItems); // Assume array of strings or objects
    } catch (err) {
      console.error("Error fetching available access items:", err);
    }
  };

  // const handleNumberOfInputFields = (e) => {
  //   const count = Math.max(0, parseInt(e.target.value) || 0);
  //   const maxFormInputs = 100;
  //   setNumberOfInputFields(count);
  //   if (count <= maxFormInputs) {
  //     setNumberOfInputFields(count);
  //     const newFields = {};
  //     for (let i = 0; i < count; i++) {
  //       newFields[`form_input_field_${i}`] =
  //         customFormInputFields[`form_input_field_${i}`] || "";
  //     }

  //     setCustomFormInputFields(newFields);
  //   } else {
  //     alert(`Maximum allowed input fields is ${maxFormInputs}.`);
  //     setNumberOfInputFields(maxFormInputs);
  //     const newFields = {};
  //     for (let i = 0; i < maxFormInputs; i++) {
  //       newFields[`form_input_field_${i}`] =
  //         customFormInputFields[`form_input_field_${i}`] || "";
  //     }
  //     setCustomFormInputFields(newFields);
  //   }
  // };

  const handleNumberOfInputFields = (e) => {
    const count = Math.max(0, parseInt(e.target.value) || 0);
    const maxFormInputs = 100;

    let finalCount = count <= maxFormInputs ? count : maxFormInputs;
    if (count > maxFormInputs) {
      alert(`Maximum allowed input fields is ${maxFormInputs}.`);
    }

    setNumberOfInputFields(finalCount);

    setCustomFormInputFields((prev) => {
      const newFields = {};

      // ✅ Keep normal fields up to finalCount
      for (let i = 0; i < finalCount; i++) {
        newFields[`form_input_field_${i}`] =
          prev[`form_input_field_${i}`] || "";
      }

      // ✅ Preserve extra dropdown if enabled
      if (enableDropdown) {
        const extraIndex = finalCount; // always after normal fields
        newFields[`form_input_field_${extraIndex}`] =
          prev[`form_input_field_${extraIndex}`] || "Machine ID";
      }

      return newFields;
    });
  };

  const handleFormInputFields = (index, value) => {
    setCustomFormInputFields((prev) => ({
      ...prev,
      [`form_input_field_${index}`]: value,
    }));
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setImageFile(reader.result);
      reader.onerror = () => console.error("Error reading file");
      reader.readAsDataURL(file);
    }
  };

  const onChangeWidget = (event) => {
    if (!event || !event.target) {
      console.error("onChangeWidget received invalid event:", event);
      return;
    }
    const value = event.target.value;
    setSettingsVisibility((prev) => ({
      ...Object.fromEntries(Object.keys(prev).map((key) => [key, false])),
      [value]: true,
    }));
  };

  const addChart = (event) => {
    event.preventDefault();
    if (!props.editWidgetModal) {
      setChartArr((prev) => [...prev, 1]);
    } else {
      const newDatasets = [
        ...props.widget.datasets,
        {
          label: `Label ${props.widget.datasets.length + 1}`,
          data: [],
          backgroundColor: "#000000",
          borderWidth: 1,
          pointRadius: 3,
          lineTension: 0.1,
          showLine: true,
        },
      ];
      updateWidget({ ...props.widget, datasets: newDatasets });
      setChartArr((prev) => [...prev, 1]);
    }
  };

  const updateWidget = (updatedWidget) => {
    if (!props.currentTarget || !Array.isArray(props.currentTarget.path)) {
      console.error(
        "currentTarget or path is missing or invalid:",
        props.currentTarget
      );
      return;
    }

    const newPaneArray = _.cloneDeep(props.paneArray);
    let current = newPaneArray;
    const path = props.currentTarget.path;

    for (let i = 0; i < path.length - 1; i++) {
      const index = path[i];
      if (!current[index] || !Array.isArray(current[index].widgetsArray)) {
        console.error(`Invalid path at index ${i}:`, path, "current:", current);
        return;
      }
      current = current[index].widgetsArray;
    }

    const lastIndex = path[path.length - 1];
    if (
      !Array.isArray(current) ||
      lastIndex >= current.length ||
      lastIndex < 0
    ) {
      console.error(
        "Invalid final index or target is not an array:",
        path,
        "current:",
        current
      );
      return;
    }
    current[lastIndex] = updatedWidget;

    props.setPaneArray(newPaneArray);
  };

  const renderSourceColorInputs = (count) =>
    Array.from({ length: count }, (_, i) => (
      <div key={i} style={{ color: "#4b5563" }}>
        <h5>Source {i + 1} Settings</h5>
        <div className="color-row">
          <div className="color-field">
            <label>Background Color:</label>
            <input
              name={`eb_bg_color_${i}`}
              className="color_input"
              type="color"
              defaultValue={
                props.editWidgetModal && props.widget?.datasets?.[i]?.k1
                  ? props.widget.datasets[i].k1
                  : "#000000"
              }
            />
          </div>
          <div className="color-field">
            <label>Border Color:</label>
            <input
              name={`eb_br_color_${i}`}
              className="color_input"
              type="color"
              defaultValue={
                props.editWidgetModal && props.widget?.datasets?.[i]?.k2
                  ? props.widget.datasets[i].k2
                  : "#000000"
              }
            />
          </div>
        </div>
        {i < count - 1 && <hr />}
      </div>
    ));

  const renderLabelValue = (count) =>
    Array.from({ length: count }, (_, i) => (
      <div className="form-row" key={i}>
        <div style={{ color: "#4b5563" }}>
          <label>Label {i + 1}:</label>
          <input
            name={`rt_label${i}`}
            defaultValue={
              props.editWidgetModal &&
              props.widget?.datasets?.[i]?.[`label${i}`]
                ? props.widget.datasets[i][`label${i}`]
                : ""
            }
            required
          />
        </div>
      </div>
    ));

  const renderStatusInputs = () =>
    Array.from({ length: numberOfStatuses }, (_, index) => (
      <div key={index} className="form-row">
        <div className="form-label">
          <label>Key {index + 1}</label>
        </div>
        <input
          type="text"
          name={`status_key_${index}`}
          value={statusPairs[index].key}
          onChange={(e) => handleStatusPairChange(index, "key", e.target.value)}
          placeholder="Enter Key (e.g., '1')"
        />
        <div className="form-label">
          <label>String {index + 1}</label>
        </div>
        <input
          type="text"
          name={`status_value_${index}`}
          value={statusPairs[index].value}
          onChange={(e) =>
            handleStatusPairChange(index, "value", e.target.value)
          }
          placeholder="Enter Display String (e.g., 'On')"
        />
      </div>
    ));

  const renderCustomFormInputFields = () =>
    Array.from({ length: numberOfInputFields }, (_, index) => (
      <div key={index} className="form-row">
        <div className="form-label">
          <label>Form Input Field {index + 1}</label>
        </div>
        <input
          type="text"
          name={`form_input_field_${index}`}
          value={customFormInputFields[`form_input_field_${index}`] || ""}
          onChange={(e) => handleFormInputFields(index, e.target.value)}
          placeholder="Enter Form Input Name"
          defaultValue={
            props.editWidgetModal &&
            props.widget?.datasets?.[0]?.customFormInputs?.[
              `form_input_field_${index}`
            ]
              ? props.widget.datasets[0].customFormInputs[
                  `form_input_field_${index}`
                ]
              : ""
          }
        />
      </div>
    ));

  // const renderRealtimeChartInputs = (isEditMode) => (
  //   <div>
  //     {(isEditMode ? props.widget?.datasets : chartArr).map((chart, ind) => (
  //       <div key={ind}>
  //         <h5>Chart {ind + 1} Settings</h5>
  //         <div className="form-row">
  //           <div className="form-label">
  //             <label>Label</label>
  //           </div>
  //           <input
  //             name={`chart_label${ind}`}
  //             defaultValue={isEditMode ? props.widget?.datasets?.[ind]?.label ?? "" : ""}
  //           />
  //         </div>
  //         <div className="form-row">
  //           <div className="form-label">
  //             <label>Background Color</label>
  //           </div>
  //           <input
  //             name={`chart_color${ind}`}
  //             className="color_input"
  //             type="color"
  //             defaultValue={
  //               isEditMode ? props.widget?.datasets?.[ind]?.backgroundColor ?? "#000000" : "#000000"
  //             }
  //           />
  //         </div>
  //         <div className="form-row">
  //           <div className="form-label">
  //             <label>Point Radius</label>
  //           </div>
  //           <input
  //             name={`chart_point_radius${ind}`}
  //             type="number"
  //             min={0}
  //             defaultValue={isEditMode ? props.widget?.datasets?.[ind]?.pointRadius ?? 3 : 3}
  //           />
  //         </div>
  //         <div className="form-row">
  //           <div className="form-label">
  //             <label>Point Background Color</label>
  //           </div>
  //           <input
  //             name={`chart_point_bg_color${ind}`}
  //             className="color_input"
  //             type="color"
  //             defaultValue={
  //               isEditMode
  //                 ? props.widget?.datasets?.[ind]?.pointBackgroundColor ?? "#000000"
  //                 : "#000000"
  //             }
  //           />
  //         </div>
  //         <div className="form-row">
  //           <div className="form-label">
  //             <label>Border Width</label>
  //           </div>
  //           <input
  //             name={`chart_border_width${ind}`}
  //             type="number"
  //             min={0}
  //             defaultValue={isEditMode ? props.widget?.datasets?.[ind]?.borderWidth ?? 1 : 1}
  //           />
  //         </div>
  //         <div className="form-row">
  //           <div className="form-label">
  //             <label>Line Tension</label>
  //           </div>
  //           <input
  //             name={`chart_line_tension${ind}`}
  //             type="number"
  //             step={0.1}
  //             min={0}
  //             max={1}
  //             defaultValue={isEditMode ? props.widget?.datasets?.[ind]?.lineTension ?? 0.1 : 0.1}
  //           />
  //         </div>
  //         <div className="form-row">
  //           <div className="form-label">
  //             <label>Show Line</label>
  //           </div>
  //           <input
  //             name={`chart_show_line${ind}`}
  //             type="checkbox"
  //             defaultChecked={isEditMode ? props.widget?.datasets?.[ind]?.showLine !== false : true}
  //           />
  //           <input type="hidden" name={`chart_show_line_hidden${ind}`} value="off" />
  //         </div>
  //         {ind < (isEditMode ? props.widget?.datasets?.length : chartArr.length) - 1 && <hr />}
  //       </div>
  //     ))}
  //     <button
  //       type="button"
  //       className="btn btn-sm btn-primary"
  //       style={{ marginTop: "5px", marginBottom: "5px" }}
  //       onClick={addChart}
  //     >
  //       Add Chart
  //     </button>
  //   </div>
  // );

  const renderRealtimeChartInputs = (isEditMode) => (
    <div className="chart-settings-container">
      {(isEditMode ? props.widget?.datasets : chartArr).map((chart, ind) => (
        <div key={ind} className="chart-card">
          <h5 className="chart-title">Chart {ind + 1} Settings</h5>

          <div className="chart-form">
            <div className="chart-field">
              <label className="chart-label">Label</label>
              <input
                name={`chart_label${ind}`}
                defaultValue={
                  isEditMode ? props.widget?.datasets?.[ind]?.label ?? "" : ""
                }
              />
            </div>

            <div className="chart-field">
              <label className="chart-label">Background Color</label>
              <input
                name={`chart_color${ind}`}
                className="color_input"
                type="color"
                defaultValue={
                  isEditMode
                    ? props.widget?.datasets?.[ind]?.backgroundColor ??
                      "#000000"
                    : "#000000"
                }
              />
            </div>

            <div className="chart-field">
              <label className="chart-label">Point Radius</label>
              <input
                name={`chart_point_radius${ind}`}
                type="number"
                min={0}
                defaultValue={
                  isEditMode
                    ? props.widget?.datasets?.[ind]?.pointRadius ?? 3
                    : 3
                }
              />
            </div>

            <div className="chart-field">
              <label className="chart-label">Point Background Color</label>
              <input
                name={`chart_point_bg_color${ind}`}
                className="color_input"
                type="color"
                defaultValue={
                  isEditMode
                    ? props.widget?.datasets?.[ind]?.pointBackgroundColor ??
                      "#000000"
                    : "#000000"
                }
              />
            </div>

            <div className="chart-field">
              <label className="chart-label">Border Width</label>
              <input
                name={`chart_border_width${ind}`}
                type="number"
                min={0}
                defaultValue={
                  isEditMode
                    ? props.widget?.datasets?.[ind]?.borderWidth ?? 1
                    : 1
                }
              />
            </div>

            <div className="chart-field">
              <label className="chart-label">Line Tension</label>
              <input
                name={`chart_line_tension${ind}`}
                type="number"
                step={0.1}
                min={0}
                max={1}
                defaultValue={
                  isEditMode
                    ? props.widget?.datasets?.[ind]?.lineTension ?? 0.1
                    : 0.1
                }
              />
            </div>

            <div className="chart-field">
              <label className="chart-label">Show Line</label>
              <input
                name={`chart_show_line${ind}`}
                type="checkbox"
                defaultChecked={
                  isEditMode
                    ? props.widget?.datasets?.[ind]?.showLine !== false
                    : true
                }
              />
              <input
                type="hidden"
                name={`chart_show_line_hidden${ind}`}
                value="off"
              />
            </div>
          </div>

          {ind <
            (isEditMode ? props.widget?.datasets?.length : chartArr.length) -
              1 && <hr />}
        </div>
      ))}

      <div className="add-chart-wrapper">
        <button type="button" className="btn btn-primary" onClick={addChart}>
          ➕ Add Chart
        </button>
      </div>
    </div>
  );

  const WidgetSelect = () => {
    const widgetOptions = [
      { value: "none", label: "None" },
      { value: "gauge", label: "Gauge Widget" },
      { value: "bar_chart", label: "Single Source Bar Chart" },
      { value: "realtime_chart", label: "Realtime Chart" },
      { value: "fluid_tank", label: "Fluid Tank" },
      { value: "custom_gauge", label: "Custom Gauge" },
      { value: "equilizer_bar", label: "Multi Source Bar Chart" },
      { value: "mqtt_writer", label: "MQTT Writer" },
      { value: "mqtt_indicator", label: "Indicator Light" },
      { value: "realtime_table", label: "Realtime Table" },
      { value: "text_widget", label: "Text Widget" },
      { value: "dynamic_text_widget", label: "Dynamic Text Widget" },
      // { value: "custom_form_widget", label: "Custom Form Widget" },
      { value: "editable_table_widget", label: "Editable Table Widget" },
      { value: "access_list_widget", label: "Access List Widget" },
      { value: "push_button", label: "Push Button Widget" },
      { value: "switch_button", label: "Switch Button Widget" },
      { value: "map_widget", label: "Map Widget" },
      { value: "nested_pane", label: "Nested Pane" },
      { value: "image_widget", label: "Image Widget" },
    ];

    return (
      <div className="form-row">
        <div className="form-label">
          <label>Widget Type</label>
        </div>
        <select
          id="widget_type"
          name="widget_type"
          onChange={props.onChangeWidget || onChangeWidget}
          defaultValue={props.widget?.widget_type ?? "none"}
        >
          {widgetOptions.map((option) => (
            <option
              key={option.value}
              value={option.value}
              disabled={
                props.editWidgetModal &&
                option.value !== props.widget?.widget_type
              }
            >
              {option.label}
            </option>
          ))}
        </select>
      </div>
    );
  };

  const handleCreateSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const widgetType = formData.get("widget_type");

    let angle = -0.03;
    let divisions = 5;
    if (widgetType === "custom_gauge") {
      angle = parseFloat(formData.get("cg_angle")) || -0.03;
      divisions = parseInt(formData.get("cg_divisions")) || 5;

      if (isNaN(angle) || angle < -1 || angle > 1) {
        alert(
          "Pointer Angle must be a number between -1 and 1. Setting to -0.03."
        );
        return;
      }
      if (isNaN(divisions) || divisions < 2) {
        alert("Divisions must be at least 2. Setting to 5.");
        return;
      }
    }

    let newWidget = {
      widget_type: widgetType,
      widget_name: formData.get("widget_name") || "Widget",
      widgetNameFontSize: parseInt(formData.get("widget_name_font_size")) || 16,
    };

    if (settingsVisibility.custom_gauge) {
      const datasets = [
        {
          unit: formData.get("cg_unit") || "",
          minValue: parseFloat(formData.get("cg_min_value")) || 0,
          maxValue: parseFloat(formData.get("cg_max_value")) || 1000,
          animationSpeed: parseInt(formData.get("cg_ani_speed")) || 32,
          angle: angle,
          lineWidth: parseFloat(formData.get("cg_gauge_width")) || 0.15,
          radiusScale: parseFloat(formData.get("cg_radius")) || 1,
          pointerLength: parseFloat(formData.get("cg_pointer_length")) || 0.5,
          pointerStrokeWidth:
            parseFloat(formData.get("cg_pointer_sw")) || 0.035,
          pointerColor: formData.get("cg_pointer_color") || "#000000",
          divisions: divisions,
          divWidth: parseFloat(formData.get("cg_dw")) || 1.1,
          divLength: parseFloat(formData.get("cg_dl")) || 0.7,
          divColor: formData.get("cg_div_color") || "#333333",
          subDivisions: parseInt(formData.get("cg_subdivisions")) || 3,
          subLength: parseFloat(formData.get("cg_sdl")) || 0.5,
          subWidth: parseFloat(formData.get("cg_sdw")) || 0.6,
          subColor: formData.get("cg_subdiv_color") || "#666666",
          limitMax: formData.get("cg_limit_max") === "on",
          limitMin: formData.get("cg_limit_min") === "on",
          colorStart: formData.get("cg_start_color") || "#6F6EA0",
          colorStop: formData.get("cg_stop_color") || "#C0C0DB",
          strokeColor: formData.get("cg_stroke_color") || "#EEEEEE",
          generateGradient: formData.get("cg_gradient") === "on",
          donut: formData.get("cg_donut") === "on",
        },
      ];
      newWidget = { ...newWidget, datasets };
    }

    if (settingsVisibility.gauge) {
      newWidget.widget_unit = formData.get("widget_unit");
      newWidget.datasets = [{}];
    }
    if (settingsVisibility.bar_chart) {
      const barCount = parseInt(formData.get("bar_count")) || 5;
      newWidget.numberOfBars = barCount;
      newWidget.datasets = [
        {
          name: formData.get("widget_name"),
          bar_bg_color: formData.get("bar_bg_color"),
          bar_br_color: formData.get("bar_br_color"),
        },
      ];
    }
    if (settingsVisibility.realtime_chart) {
      newWidget.datasets = chartArr.map((_, ind) => ({
        label: formData.get(`chart_label${ind}`),
        data: [],
        backgroundColor: formData.get(`chart_color${ind}`),
        borderWidth: parseInt(formData.get(`chart_border_width${ind}`)) || 1,
        pointRadius: parseInt(formData.get(`chart_point_radius${ind}`)) || 3,
        pointBackgroundColor:
          formData.get(`chart_point_bg_color${ind}`) || "#000000",
        lineTension:
          parseFloat(formData.get(`chart_line_tension${ind}`)) || 0.1,
        showLine: formData.get(`chart_show_line${ind}`) === "on",
      }));
    }
    if (settingsVisibility.fluid_tank) {
      newWidget.lower_limit = parseFloat(formData.get("lower_limit")) || 0;
      newWidget.upper_limit = parseFloat(formData.get("upper_limit")) || 100;
      newWidget.datasets = [{}];
    }
    if (settingsVisibility.equilizer_bar) {
      const sourceCount = parseInt(formData.get("eb_src_cnt")) || 1;
      newWidget.datasets = Array(sourceCount)
        .fill()
        .map((_, ind) => ({
          name: ind === 0 ? formData.get("widget_name") : undefined,
          sourceCnt: sourceCount,
          idx: ind,
          k1: formData.get(`eb_bg_color_${ind}`) || "#000000",
          k2: formData.get(`eb_br_color_${ind}`) || "#000000",
        }));
      newWidget.datasource = Array(sourceCount)
        .fill()
        .map((_, ind) => ({
          id: ind + 1,
          name: `Source ${ind + 1}`,
          type: "MQTT",
        }));
    }
    if (settingsVisibility.mqtt_writer) {
      newWidget.datasets = [
        {
          host: formData.get("mw_server"),
          port: parseInt(formData.get("mw_port")) || 1883,
          topic: formData.get("mw_topic"),
          username: formData.get("mw_username") || undefined,
          password: formData.get("mw_password") || undefined,
          clientId: formData.get("mw_clientId") || undefined,
        },
      ];
    }
    if (settingsVisibility.mqtt_indicator) {
      newWidget.datasets = [
        {
          offText: formData.get("mi_off_text") || "",
          onText: formData.get("mi_on_text") || "",
          refreshInterval: parseInt(formData.get("mi_refresh")) || 2000,
          title: formData.get("widget_name") || "",
        },
      ];
    }
    if (settingsVisibility.realtime_table) {
      newWidget.tableName = formData.get("widget_name");
      newWidget.columns = parseInt(formData.get("rt_noc")) || 1;
      newWidget.datasets = Array(parseInt(formData.get("rt_noc")) || 1)
        .fill()
        .map((_, i) => ({ [`label${i}`]: formData.get(`rt_label${i}`) || "" }));
      newWidget.widgetProperty = {
        tableName: formData.get("widget_name"),
        columns: parseInt(formData.get("rt_noc")) || 1,
        maxRows: parseInt(formData.get("maxRows")) || 100,
        maxRowsPerPage: Math.max(
          1,
          parseInt(formData.get("maxRowsPerPage")) || 10
        ),
        showTimeColumn: formData.get("showTimeColumn") === "on",
        updateInterval: parseInt(formData.get("updateInterval")) || 2000,
        backgroundColor: formData.get("backgroundColor") || "white",
        textColor: formData.get("textColor") || "black",
        fontSize: formData.get("fontSize") || "14px",
        borderColor: formData.get("borderColor") || "#ccc",
      };
    }
    if (settingsVisibility.text_widget) {
      newWidget.datasets = [
        {
          name: formData.get("widget_name"),
          text: formData.get("text_content") || "Default Text",
          fontSize: parseInt(formData.get("text_font_size")) || 16,
          fontWeight: parseInt(formData.get("text_font_weight")) || 300,
          textColor: formData.get("text_color") || "#ffffffff",
          backgroundColor: formData.get("text_background_color") || "#28282b",
        },
      ];
    }
    if (settingsVisibility.dynamic_text_widget) {
      newWidget.datasets = [
        {
          name: formData.get("widget_name"),
          logicInput: formData.get("logic_input"),
          fontSize:
            parseInt(formData.get("dynamic_text_widget_font_size")) || 16,
          fontWeight:
            parseInt(formData.get("dynamic_text_widget_font_weight")) || 300,
          statusPairs: statusPairs,
        },
      ];
      newWidget.datasource = [
        {
          name: formData.get("widget_name") || "default-source",
          type: "MQTT",
        },
      ];
    }
    // if (settingsVisibility.custom_form_widget) {
    //   newWidget.datasets = [
    //     {
    //       name: formData.get("widget_name"),
    //       host: formData.get("mw_server"),
    //       port: parseInt(formData.get("mw_port")) || 1883,
    //       topic: formData.get("mw_topic"),
    //       customFormInputs: customFormInputFields,
    //       numberOfInputFields: numberOfInputFields,
    //       username: formData.get("mw_username") || undefined,
    //       password: formData.get("mw_password") || undefined,
    //       clientId: formData.get("mw_clientId") || undefined,
    //     },
    //   ];
    // }
    if (settingsVisibility.editable_table_widget) {
      newWidget.datasets = [
        {
          name: formData.get("widget_name"),
          host: formData.get("mw_server"),
          port: parseInt(formData.get("mw_port")) || 1883,
          topic: formData.get("mw_topic"),
          customFormInputs: customFormInputFields,
          numberOfInputFields: numberOfInputFields,
          username: formData.get("mw_username") || undefined,
          password: formData.get("mw_password") || undefined,
          clientId: formData.get("mw_clientId") || undefined,
          enableExtraDropdown: formData.get("enable_extra_dropdown") === "on",
          extraOptions: enableDropdown ? extraOptions : [],
        },
      ];
    }
    if (settingsVisibility.access_list_widget) {
      newWidget.datasets = [
        {
          name: formData.get("widget_name"),
          host: formData.get("mw_server"),
          port: parseInt(formData.get("mw_port")) || 1883,
          topic: formData.get("mw_topic"),
          selectedAccessItems: formData.get("selected_access_items"), // store selected data
          username: formData.get("mw_username") || undefined,
          password: formData.get("mw_password") || undefined,
          clientId: formData.get("mw_clientId") || undefined,
        },
      ];
    }
    if (settingsVisibility.push_button) {
      newWidget.datasets = [
        {
          name: formData.get("widget_name"),
          host: formData.get("mw_server"),
          port: parseInt(formData.get("mw_port")) || 1883,
          topic: formData.get("mw_topic"),
          username: formData.get("mw_username") || undefined,
          password: formData.get("mw_password") || undefined,
          clientId: formData.get("mw_clientId") || undefined,
          payload_off: formData.get("mi_off_text") || "",
          payload_on: formData.get("mi_on_text") || "",
        },
      ];
    }
    if (settingsVisibility.switch_button) {
      newWidget.datasets = [
        {
          name: formData.get("widget_name"),
          host: formData.get("mw_server"),
          port: parseInt(formData.get("mw_port")) || 1883,
          topic: formData.get("mw_topic"),
          username: formData.get("mw_username") || undefined,
          password: formData.get("mw_password") || undefined,
          clientId: formData.get("mw_clientId") || undefined,
          payload_off: formData.get("mi_off_text") || "",
          payload_on: formData.get("mi_on_text") || "",
          refreshInterval: parseInt(formData.get("mi_refresh")) || 2000,
        },
      ];
    }
    // if (settingsVisibility.map_widget) {
    //   const deviceCount = parseInt(formData.get("mw_device_cnt")) || 1;
    //   newWidget.datasets = [
    //     {
    //       // Basic info
    //       name: formData.get("mw_name") || "Map Widget",
    //       sourceCnt: sourceCount,
    //       // Map-specific settings
    //       center: formData.get("mw_center")
    //         ? formData
    //             .get("mw_center")
    //             .split(",")
    //             .map((val) => parseFloat(val.trim()))
    //         : [20.5937, 78.9629], // default center
    //       zoom: parseInt(formData.get("mw_zoom")) || 10,
    //       refreshInterval: parseInt(formData.get("mw_refresh_interval")) || 10,

    //       // Geofence
    //       geofence: (() => {
    //         const type = formData.get("mw_geofence_type") || "circle";
    //         const enabled = formData.get("mw_geofence_enable") === "on";
    //         if (type === "circle") {
    //           return {
    //             enabled,
    //             type,
    //             center: formData.get("mw_center")
    //               ? formData
    //                   .get("mw_center")
    //                   .split(",")
    //                   .map((val) => parseFloat(val.trim()))
    //               : [20.5937, 78.9629],
    //             radius: parseFloat(formData.get("mw_geofence_radius")) || 100,
    //           };
    //         } else {
    //           let coordinates = [];
    //           try {
    //             coordinates = JSON.parse(
    //               formData.get("mw_geofence_coordinates") || "[]"
    //             );
    //           } catch (err) {
    //             coordinates = [];
    //           }
    //           return { enabled, type, coordinates };
    //         }
    //       })(),

    //       // Markers & display options
    //       markers: { enabled: formData.get("mw_markers_enable") === "on" },
    //       heatmap: formData.get("mw_heatmap") === "on",
    //     },
    //   ];

      

    //   newWidget.datasource = Array(deviceCount)
    //     .fill()
    //     .map((_, ind) => ({
    //       id: ind + 1,
    //       name: formData.get(`mw_device_name_${ind}`) || `Device ${ind + 1}`,
    //       type: "MQTT"
    //     }));
    // }

    if (settingsVisibility.map_widget) {
      const deviceCount = parseInt(formData.get("mw_device_cnt")) || 1;

      // Build datasets (like bar widget)
      newWidget.datasets = Array(mapDeviceSourceCount)
        .fill()
        .map((_, ind) => {
          const isFirst = ind === 0; // only first device carries map-wide settings

          return {
            deviceIndex: ind,

            /***************************************
             ✅ MAP-WIDE SETTINGS (ONLY FIRST DATASET)
            ****************************************/
            ...(isFirst && {
              name: formData.get("mw_name") || "Map Widget",

              sourceCnt: mapDeviceSourceCount,

              // Map basics
              center: formData.get("mw_center")
                ? formData
                    .get("mw_center")
                    .split(",")
                    .map((val) => parseFloat(val.trim()))
                : [20.5937, 78.9629],

              zoom: parseInt(formData.get("mw_zoom")) || 10,
              refreshInterval: parseInt(formData.get("mw_refresh_interval")) || 10,

              // Geofence
              geofence: (() => {
                const type = formData.get("mw_geofence_type") || "circle";
                const enabled = formData.get("mw_geofence_enable") === "on";

                if (type === "circle") {
                  return {
                    enabled,
                    type,
                    center: formData.get("mw_center")
                      ? formData
                          .get("mw_center")
                          .split(",")
                          .map((val) => parseFloat(val.trim()))
                      : [20.5937, 78.9629],
                    radius: parseFloat(formData.get("mw_geofence_radius")) || 100,
                  };
                } else {
                  let coordinates = [];
                  try {
                    coordinates = JSON.parse(
                      formData.get("mw_geofence_coordinates") || "[]"
                    );
                  } catch (err) {
                    coordinates = [];
                  }
                  return { enabled, type, coordinates };
                }
              })(),

              // Map display options
              markers: { enabled: formData.get("mw_markers_enable") === "on" },
              heatmap: formData.get("mw_heatmap") === "on",
            }),

            /***************************************
             ✅ PER-DEVICE CONFIG (ALL DATASETS)
            ****************************************/
            name:
              formData.get(`mw_device_name_${ind}`) || `Device ${ind + 1}`,
              idx:ind,
            // sourceId: formData.get(`mw_device_src_${ind}`) || null,
            color: formData.get(`mw_device_color_${ind}`) || "#FF0000",
            icon: formData.get(`mw_device_icon_${ind}`) || "car",
          };
        });

      /***************************************
       ✅ DATASOURCE ARRAY MATCHING BAR WIDGET
      ****************************************/
      newWidget.datasource = Array(mapDeviceSourceCount)
            .fill()
            .map((_, ind) => ({
              id: ind + 1,
              name: `Device ${ind + 1}`,
              type: "MQTT",
            }));
    }


    if (settingsVisibility.nested_pane) {
      newWidget.widget_name = formData.get("widget_name");
    }
    if (settingsVisibility.image_widget) {
      newWidget.imageData = imageFile;
    }

    props.widgetSettupHandler(newWidget);
    props.toggleModal();
  };

  const handleEditSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const widgetType = props.widget?.widget_type;

    let angle = -0.03;
    let divisions = 5;
    if (widgetType === "custom_gauge") {
      angle =
        parseFloat(formData.get("cg_angle")) ||
        props.widget?.datasets?.[0]?.angle ||
        -0.03;
      divisions =
        parseInt(formData.get("cg_divisions")) ||
        props.widget?.datasets?.[0]?.divisions ||
        5;

      if (isNaN(angle) || angle < -1 || angle > 1) {
        alert(
          "Pointer Angle must be a number between -1 and 1. Setting to -0.03."
        );
        return;
      }
      if (isNaN(divisions) || divisions < 2) {
        alert("Divisions must be at least 2. Setting to 5.");
        return;
      }
    }
    

    const updatedWidget = {
      ...props.widget,
      widget_name: formData.get("widget_name") || props.widget?.widget_name,
      widgetNameFontSize:
        parseInt(formData.get("widget_name_font_size")) ||
        props.widget?.widgetNameFontSize ||
        16,
      ...(settingsVisibility.gauge && {
        widget_unit: formData.get("widget_unit") || props.widget?.widget_unit,
        datasets: props.widget?.datasets || [{}],
      }),
      ...(settingsVisibility.bar_chart && {
        numberOfBars:
          parseInt(formData.get("bar_count")) ||
          props.widget?.numberOfBars ||
          5,
        datasets: [
          {
            ...props.widget?.datasets?.[0],
            name:
              formData.get("widget_name") || props.widget?.datasets?.[0]?.name,
            bar_bg_color:
              formData.get("bar_bg_color") ||
              props.widget?.datasets?.[0]?.bar_bg_color,
            bar_br_color:
              formData.get("bar_br_color") ||
              props.widget?.datasets?.[0]?.bar_br_color,
          },
        ],
      }),
      ...(settingsVisibility.realtime_chart && {
        datasets: props.widget?.datasets?.map((dataset, ind) => ({
          ...dataset,
          label: formData.get(`chart_label${ind}`) || dataset?.label,
          backgroundColor:
            formData.get(`chart_color${ind}`) || dataset?.backgroundColor,
          pointRadius:
            parseInt(formData.get(`chart_point_radius${ind}`)) ||
            dataset?.pointRadius ||
            3,
          pointBackgroundColor:
            formData.get(`chart_point_bg_color${ind}`) ||
            dataset?.pointBackgroundColor ||
            "#000000",
          borderWidth:
            parseInt(formData.get(`chart_border_width${ind}`)) ||
            dataset?.borderWidth ||
            1,
          lineTension:
            parseFloat(formData.get(`chart_line_tension${ind}`)) ||
            dataset?.lineTension ||
            0.1,
          showLine: formData.get(`chart_show_line${ind}`) === "on",
        })),
      }),
      ...(settingsVisibility.fluid_tank && {
        lower_limit:
          parseFloat(formData.get("lower_limit")) ||
          props.widget?.lower_limit ||
          0,
        upper_limit:
          parseFloat(formData.get("upper_limit")) ||
          props.widget?.upper_limit ||
          100,
        datasets: props.widget?.datasets || [{}],
      }),
      ...(settingsVisibility.custom_gauge && {
        datasets: [
          {
            ...props.widget?.datasets?.[0],
            unit: formData.get("cg_unit") || props.widget?.datasets?.[0]?.unit,
            minValue:
              parseFloat(formData.get("cg_min_value")) ||
              props.widget?.datasets?.[0]?.minValue ||
              0,
            maxValue:
              parseFloat(formData.get("cg_max_value")) ||
              props.widget?.datasets?.[0]?.maxValue ||
              1000,
            animationSpeed:
              parseInt(formData.get("cg_ani_speed")) ||
              props.widget?.datasets?.[0]?.animationSpeed ||
              32,
            angle: angle,
            lineWidth:
              parseFloat(formData.get("cg_gauge_width")) ||
              props.widget?.datasets?.[0]?.lineWidth ||
              0.15,
            radiusScale:
              parseFloat(formData.get("cg_radius")) ||
              props.widget?.datasets?.[0]?.radiusScale ||
              1,
            pointerLength:
              parseFloat(formData.get("cg_pointer_length")) ||
              props.widget?.datasets?.[0]?.pointerLength ||
              0.5,
            pointerStrokeWidth:
              parseFloat(formData.get("cg_pointer_sw")) ||
              props.widget?.datasets?.[0]?.pointerStrokeWidth ||
              0.035,
            pointerColor:
              formData.get("cg_pointer_color") ||
              props.widget?.datasets?.[0]?.pointerColor ||
              "#000000",
            divisions: divisions,
            divWidth:
              parseFloat(formData.get("cg_dw")) ||
              props.widget?.datasets?.[0]?.divWidth ||
              1.1,
            divLength:
              parseFloat(formData.get("cg_dl")) ||
              props.widget?.datasets?.[0]?.divLength ||
              0.7,
            divColor:
              formData.get("cg_div_color") ||
              props.widget?.datasets?.[0]?.divColor ||
              "#333333",
            subDivisions:
              parseInt(formData.get("cg_subdivisions")) ||
              props.widget?.datasets?.[0]?.subDivisions ||
              3,
            subLength:
              parseFloat(formData.get("cg_sdl")) ||
              props.widget?.datasets?.[0]?.subLength ||
              0.5,
            subWidth:
              parseFloat(formData.get("cg_sdw")) ||
              props.widget?.datasets?.[0]?.subWidth ||
              0.6,
            subColor:
              formData.get("cg_subdiv_color") ||
              props.widget?.datasets?.[0]?.subColor ||
              "#666666",
            limitMax: formData.get("cg_limit_max") === "on",
            limitMin: formData.get("cg_limit_min") === "on",
            colorStart:
              formData.get("cg_start_color") ||
              props.widget?.datasets?.[0]?.colorStart ||
              "#6F6EA0",
            colorStop:
              formData.get("cg_stop_color") ||
              props.widget?.datasets?.[0]?.colorStop ||
              "#C0C0DB",
            strokeColor:
              formData.get("cg_stroke_color") ||
              props.widget?.datasets?.[0]?.strokeColor ||
              "#EEEEEE",
            generateGradient: formData.get("cg_gradient") === "on",
            donut: formData.get("cg_donut") === "on",
          },
        ],
      }),
      ...(settingsVisibility.equilizer_bar && {
        datasets: Array(
          parseInt(formData.get("eb_src_cnt")) ||
            props.widget?.datasets?.[0]?.sourceCnt ||
            1
        )
          .fill()
          .map((_, ind) => ({
            ...(props.widget?.datasets?.[ind] || {}),
            name:
              ind === 0
                ? formData.get("widget_name") ||
                  props.widget?.datasets?.[0]?.name
                : undefined,
            sourceCnt:
              parseInt(formData.get("eb_src_cnt")) ||
              props.widget?.datasets?.[0]?.sourceCnt ||
              1,
            idx: ind,
            k1:
              formData.get(`eb_bg_color_${ind}`) ||
              props.widget?.datasets?.[ind]?.k1 ||
              "#000000",
            k2:
              formData.get(`eb_br_color_${ind}`) ||
              props.widget?.datasets?.[ind]?.k2 ||
              "#000000",
          })),
        datasource:
          props.widget?.datasource ||
          Array(
            parseInt(formData.get("eb_src_cnt")) ||
              props.widget?.datasets?.[0]?.sourceCnt ||
              1
          )
            .fill()
            .map((_, ind) => ({
              id: ind + 1,
              name: `Source ${ind + 1}`,
              type: "MQTT",
            })),
      }),
      ...(settingsVisibility.mqtt_writer && {
        datasets: [
          {
            ...props.widget?.datasets?.[0],
            host:
              formData.get("mw_server") || props.widget?.datasets?.[0]?.host,
            port:
              parseInt(formData.get("mw_port")) ||
              props.widget?.datasets?.[0]?.port ||
              1883,
            topic:
              formData.get("mw_topic") || props.widget?.datasets?.[0]?.topic,
            username:
              formData.get("mw_username") ||
              props.widget?.datasets?.[0]?.username ||
              undefined,
            password:
              formData.get("mw_password") ||
              props.widget?.datasets?.[0]?.password ||
              undefined,
            clientId:
              formData.get("mw_clientId") ||
              props.widget?.datasets?.[0]?.clientId ||
              undefined,
          },
        ],
      }),
      ...(settingsVisibility.mqtt_indicator && {
        datasets: [
          {
            ...props.widget?.datasets?.[0],
            title:
              formData.get("widget_name") ||
              props.widget?.datasets?.[0]?.title ||
              "",
            onText:
              formData.get("mi_on_text") ||
              props.widget?.datasets?.[0]?.onText ||
              "",
            offText:
              formData.get("mi_off_text") ||
              props.widget?.datasets?.[0]?.offText ||
              "",
            refreshInterval:
              parseInt(formData.get("mi_refresh")) ||
              props.widget?.datasets?.[0]?.refreshInterval ||
              2000,
          },
        ],
      }),
      ...(settingsVisibility.realtime_table && {
        tableName: formData.get("widget_name") || props.widget?.tableName,
        columns: parseInt(formData.get("rt_noc")) || props.widget?.columns || 1,
        datasets: Array(
          parseInt(formData.get("rt_noc")) || props.widget?.columns || 1
        )
          .fill()
          .map((_, i) => ({
            [`label${i}`]:
              formData.get(`rt_label${i}`) ||
              props.widget?.datasets?.[i]?.[`label${i}`] ||
              "",
          })),
        widgetProperty: {
          tableName: formData.get("widget_name") || props.widget?.tableName,
          columns:
            parseInt(formData.get("rt_noc")) || props.widget?.columns || 1,
          maxRows:
            parseInt(formData.get("maxRows")) ||
            props.widget?.widgetProperty?.maxRows ||
            100,
          maxRowsPerPage: Math.max(
            1,
            parseInt(formData.get("maxRowsPerPage")) ||
              props.widget?.widgetProperty?.maxRowsPerPage ||
              10
          ),
          showTimeColumn: formData.get("showTimeColumn") === "on",
          updateInterval:
            parseInt(formData.get("updateInterval")) ||
            props.widget?.widgetProperty?.updateInterval ||
            2000,
          backgroundColor:
            formData.get("backgroundColor") ||
            props.widget?.widgetProperty?.backgroundColor ||
            "white",
          textColor:
            formData.get("textColor") ||
            props.widget?.widgetProperty?.textColor ||
            "black",
          fontSize:
            formData.get("fontSize") ||
            props.widget?.widgetProperty?.fontSize ||
            "14px",
          borderColor:
            formData.get("borderColor") ||
            props.widget?.widgetProperty?.borderColor ||
            "#ccc",
        },
      }),
      ...(settingsVisibility.text_widget && {
        datasets: [
          {
            ...props.widget?.datasets?.[0],
            name:
              formData.get("widget_name") || props.widget?.datasets?.[0]?.name,
            text:
              formData.get("text_content") || props.widget?.datasets?.[0]?.text,
            fontSize:
              parseInt(formData.get("text_font_size")) ||
              props.widget?.datasets?.[0]?.fontSize ||
              16,
            fontWeight:
              parseInt(formData.get("text_font_weight")) ||
              props.widget?.datasets?.[0]?.fontWeight ||
              300,
            textColor:
              formData.get("text_color") ||
              props.widget?.datasets?.[0]?.textColor ||
              "#ffffffff",
            backgroundColor:
              formData.get("text_background_color") ||
              props.widget?.datasets?.[0]?.backgroundColor ||
              "#28282b",
          },
        ],
      }),
      ...(settingsVisibility.dynamic_text_widget && {
        datasets: [
          {
            ...props.widget?.datasets?.[0],
            name:
              formData.get("widget_name") || props.widget?.datasets?.[0]?.name,
            logicInput:
              formData.get("logic_input") ||
              props.widget?.datasets?.[0]?.logicInput,
            fontSize:
              parseInt(formData.get("dynamic_text_widget_font_size")) ||
              props.widget?.datasets?.[0]?.fontSize ||
              16,
            fontWeight:
              parseInt(formData.get("dynamic_text_widget_font_weight")) ||
              props.widget?.datasets?.[0]?.fontWeight ||
              300,
            statusPairs: statusPairs,
          },
        ],
        datasource: [
          {
            name:
              formData.get("widget_name") ||
              props.widget?.datasource?.[0]?.name ||
              "default-source",
            type: "MQTT",
          },
        ],
      }),
      ...(settingsVisibility.custom_form_widget && {
        datasets: [
          {
            ...props.widget?.datasets?.[0],
            name:
              formData.get("widget_name") || props.widget?.datasets?.[0]?.name,
            host:
              formData.get("mw_server") || props.widget?.datasets?.[0]?.host,
            port:
              parseInt(formData.get("mw_port")) ||
              props.widget?.datasets?.[0]?.port ||
              1883,
            topic:
              formData.get("mw_topic") || props.widget?.datasets?.[0]?.topic,
            customFormInputs: customFormInputFields,
            numberOfInputFields: numberOfInputFields,
            username:
              formData.get("mw_username") ||
              props.widget?.datasets?.[0]?.username ||
              undefined,
            password:
              formData.get("mw_password") ||
              props.widget?.datasets?.[0]?.password ||
              undefined,
            clientId:
              formData.get("mw_clientId") ||
              props.widget?.datasets?.[0]?.clientId ||
              undefined,
          },
        ],
      }),
      ...(settingsVisibility.editable_table_widget && {
        datasets: [
          {
            ...props.widget?.datasets?.[0],
            name:
              formData.get("widget_name") || props.widget?.datasets?.[0]?.name,
            host:
              formData.get("mw_server") || props.widget?.datasets?.[0]?.host,
            port:
              parseInt(formData.get("mw_port")) ||
              props.widget?.datasets?.[0]?.port ||
              1883,
            topic:
              formData.get("mw_topic") || props.widget?.datasets?.[0]?.topic,
            customFormInputs: customFormInputFields,
            numberOfInputFields: numberOfInputFields,
            username:
              formData.get("mw_username") ||
              props.widget?.datasets?.[0]?.username ||
              undefined,
            password:
              formData.get("mw_password") ||
              props.widget?.datasets?.[0]?.password ||
              undefined,
            clientId:
              formData.get("mw_clientId") ||
              props.widget?.datasets?.[0]?.clientId ||
              undefined,
            enableExtraDropdown: formData.has("enable_extra_dropdown")
              ? formData.get("enable_extra_dropdown") === "on"
              : false,

            extraOptions: enableDropdown ? extraOptions : [],
          },
        ],
      }),
      ...(settingsVisibility.access_list_widget && {
        datasets: [
          {
            ...props.widget?.datasets?.[0],
            name:
              formData.get("widget_name") || props.widget?.datasets?.[0]?.name,
            host:
              formData.get("mw_server") || props.widget?.datasets?.[0]?.host,
            port:
              parseInt(formData.get("mw_port")) ||
              props.widget?.datasets?.[0]?.port ||
              1883,
            topic:
              formData.get("mw_topic") || props.widget?.datasets?.[0]?.topic,
            selectedAccessItems: selectedAccessItems,
            username:
              formData.get("mw_username") ||
              props.widget?.datasets?.[0]?.username ||
              undefined,
            password:
              formData.get("mw_password") ||
              props.widget?.datasets?.[0]?.password ||
              undefined,
            clientId:
              formData.get("mw_clientId") ||
              props.widget?.datasets?.[0]?.clientId ||
              undefined,
          },
        ],
      }),
      ...(settingsVisibility.push_button && {
        datasets: [
          {
            ...props.widget?.datasets?.[0],
            name:
              formData.get("widget_name") || props.widget?.datasets?.[0]?.name,
            host:
              formData.get("mw_server") || props.widget?.datasets?.[0]?.host,
            port:
              parseInt(formData.get("mw_port")) ||
              props.widget?.datasets?.[0]?.port ||
              1883,
            topic:
              formData.get("mw_topic") || props.widget?.datasets?.[0]?.topic,
            payload_on:
              formData.get("mi_on_text") ||
              props.widget?.datasets?.[0]?.payload_on ||
              "",
            payload_off:
              formData.get("mi_off_text") ||
              props.widget?.datasets?.[0]?.payload_off ||
              "",

            username:
              formData.get("mw_username") ||
              props.widget?.datasets?.[0]?.username ||
              undefined,
            password:
              formData.get("mw_password") ||
              props.widget?.datasets?.[0]?.password ||
              undefined,
            clientId:
              formData.get("mw_clientId") ||
              props.widget?.datasets?.[0]?.clientId ||
              undefined,
          },
        ],
      }),
      ...(settingsVisibility.switch_button && {
        datasets: [
          {
            ...props.widget?.datasets?.[0],
            name:
              formData.get("widget_name") || props.widget?.datasets?.[0]?.name,
            host:
              formData.get("mw_server") || props.widget?.datasets?.[0]?.host,
            port:
              parseInt(formData.get("mw_port")) ||
              props.widget?.datasets?.[0]?.port ||
              1883,
            topic:
              formData.get("mw_topic") || props.widget?.datasets?.[0]?.topic,
            payload_on:
              formData.get("mi_on_text") ||
              props.widget?.datasets?.[0]?.payload_on ||
              "",
            payload_off:
              formData.get("mi_off_text") ||
              props.widget?.datasets?.[0]?.payload_off ||
              "",
            refreshInterval:
              parseInt(formData.get("mi_refresh")) ||
              props.widget?.datasets?.[0]?.refreshInterval ||
              2000,
            username:
              formData.get("mw_username") ||
              props.widget?.datasets?.[0]?.username ||
              undefined,
            password:
              formData.get("mw_password") ||
              props.widget?.datasets?.[0]?.password ||
              undefined,
            clientId:
              formData.get("mw_clientId") ||
              props.widget?.datasets?.[0]?.clientId ||
              undefined,
          },
        ],
      }),
      // ...(settingsVisibility.map_widget && {
      //   datasets: [
      //     {
      //       ...props.widget?.datasets?.[0],
      //       sourceCnt:
      //         parseInt(formData.get("mw_device_cnt")) ||
      //         props.widget?.datasets?.[0]?.sourceCnt ||
      //         1,
      //       // Basic info
      //       name: formData.get("mw_name") || props.widget?.datasets?.[0]?.name,

      //       // Map-specific settings
      //       center: formData.get("mw_center")
      //         ? formData
      //             .get("mw_center")
      //             .split(",")
      //             .map((val) => parseFloat(val.trim()))
      //         : props.widget?.datasets?.[0]?.center || [20.5937, 78.9629],
      //       zoom:
      //         parseInt(formData.get("mw_zoom")) ||
      //         props.widget?.datasets?.[0]?.zoom ||
      //         10,
      //       refreshInterval:
      //         parseInt(formData.get("mw_refresh_interval")) ||
      //         props.widget?.datasets?.[0]?.refreshInterval ||
      //         10,

      //       // Geofence
      //       geofence: (() => {
      //         const type =
      //           formData.get("mw_geofence_type") ||
      //           props.widget?.datasets?.[0]?.geofence?.type ||
      //           "circle";
      //         const enabled =
      //           formData.get("mw_geofence_enable") === "on" ||
      //           props.widget?.datasets?.[0]?.geofence?.enabled;
      //         if (type === "circle") {
      //           return {
      //             enabled,
      //             type,
      //             center: formData.get("mw_center")
      //               ? formData
      //                   .get("mw_center")
      //                   .split(",")
      //                   .map((val) => parseFloat(val.trim()))
      //               : props.widget?.datasets?.[0]?.geofence?.center || [
      //                   20.5937, 78.9629,
      //                 ],
      //             radius:
      //               parseFloat(formData.get("mw_geofence_radius")) ||
      //               props.widget?.datasets?.[0]?.geofence?.radius ||
      //               100,
      //           };
      //         } else {
      //           let coordinates = [];
      //           try {
      //             coordinates =
      //               JSON.parse(formData.get("mw_geofence_coordinates")) ||
      //               props.widget?.datasets?.[0]?.geofence?.coordinates ||
      //               [];
      //           } catch (err) {
      //             coordinates =
      //               props.widget?.datasets?.[0]?.geofence?.coordinates || [];
      //           }
      //           return { enabled, type, coordinates };
      //         }
      //       })(),

      //       // Markers & display options
      //       markers: {
      //         enabled:
      //           formData.get("mw_markers_enable") === "on" ||
      //           props.widget?.datasets?.[0]?.markers?.enabled ||
      //           false,
      //       },
      //       heatmap:
      //         formData.get("mw_heatmap") === "on" ||
      //         props.widget?.datasets?.[0]?.heatmap ||
      //         false,
      //     },
      //   ],
      //    datasource:
      //     props.widget?.datasource ||
      //     Array(
      //       parseInt(formData.get("mw_device_cnt")) ||
      //         props.widget?.datasets?.[0]?.sourceCnt ||
      //         1
      //     )
      //       .fill()
      //       .map((_, ind) => ({
      //         id: ind + 1,
      //         name: `Device ${ind + 1}`,
      //         type: "MQTT",
      //       })),
      // }),



      ...(settingsVisibility.map_widget && {
      datasets: Array(
        parseInt(formData.get("mw_device_cnt")) ||
          props.widget?.datasets?.[0]?.sourceCnt ||
          1
      )
        .fill()
        .map((_, ind) => {
          const deviceCount =
            parseInt(formData.get("mw_device_cnt")) ||
            props.widget?.datasets?.[0]?.sourceCnt ||
            1;

          const existingDataset = props.widget?.datasets?.[ind] || {};

          const isFirst = ind === 0; // only first dataset carries map-wide settings

          return {
            ...existingDataset,

            // Store total device count
            sourceCnt: deviceCount,

            /***************************************
             * ✅ MAP-WIDE SETTINGS (ONLY IN FIRST)
             ****************************************/
            ...(isFirst && {
              name:
                formData.get("mw_name") ||
                props.widget?.datasets?.[0]?.name ||
                "Map Widget",

              center: formData.get("mw_center")
                ? formData
                    .get("mw_center")
                    .split(",")
                    .map((val) => parseFloat(val.trim()))
                : props.widget?.datasets?.[0]?.center || [20.5937, 78.9629],

              zoom:
                parseInt(formData.get("mw_zoom")) ||
                props.widget?.datasets?.[0]?.zoom ||
                10,

              refreshInterval:
                parseInt(formData.get("mw_refresh_interval")) ||
                props.widget?.datasets?.[0]?.refreshInterval ||
                10,

              geofence: (() => {
                const type =
                  formData.get("mw_geofence_type") ||
                  props.widget?.datasets?.[0]?.geofence?.type ||
                  "circle";
                const enabled =
                  formData.get("mw_geofence_enable") === "on" 

                if (type === "circle") {
                  return {
                    enabled,
                    type,
                    center: formData.get("mw_center")
                      ? formData
                          .get("mw_center")
                          .split(",")
                          .map((val) => parseFloat(val.trim()))
                      : props.widget?.datasets?.[0]?.geofence?.center || [
                          20.5937, 78.9629,
                        ],
                    radius:
                      parseFloat(formData.get("mw_geofence_radius")) ||
                      props.widget?.datasets?.[0]?.geofence?.radius ||
                      100,
                  };
                } else {
                  let coordinates = [];
                  try {
                    coordinates =
                      JSON.parse(formData.get("mw_geofence_coordinates")) ||
                      props.widget?.datasets?.[0]?.geofence?.coordinates ||
                      [];
                  } catch (err) {
                    coordinates =
                      props.widget?.datasets?.[0]?.geofence?.coordinates || [];
                  }
                  return { enabled, type, coordinates };
                }
              })(),

              markers: {
                enabled:
                  formData.get("mw_markers_enable") === "on"
              },

              heatmap:
                formData.get("mw_heatmap") === "on" ||
                props.widget?.datasets?.[0]?.heatmap ||
                false,
            }),

            /***************************************
             * ✅ PER-DEVICE SETTINGS (EACH DATASET)
             ****************************************/
            idx: ind,
            deviceName:
              formData.get(`mw_device_name_${ind}`) ||
              existingDataset.deviceName ||
              `Device ${ind + 1}`,

            // sourceId:
            //   formData.get(`mw_device_src_${ind}`) ||
            //   existingDataset.sourceId ||
            //   null,

            icon:
              formData.get(`mw_device_icon_${ind}`) ||
              existingDataset.icon ||
              "car",

            color:
              formData.get(`mw_device_color_${ind}`) ||
              existingDataset.color ||
              "#FF0000",
          };
        }
      ),

      /***************************************
       * ✅ DATASOURCE (SAME STYLE AS BAR)
       ****************************************/
      datasource:
        props.widget?.datasource ||
        Array(
          parseInt(formData.get("mw_device_cnt")) ||
            props.widget?.datasets?.[0]?.sourceCnt ||
            1
        )
          .fill()
          .map((_, ind) => ({
            id: ind + 1,
            name: `Device ${ind + 1}`,
            type: "MQTT",
          })),
    }),


      ...(settingsVisibility.nested_pane && {
        widget_name: formData.get("widget_name") || props.widget?.widget_name,
      }),
      ...(settingsVisibility.image_widget && {
        imageData: imageFile || props.widget?.imageData,
      }),
    };

    updateWidget(updatedWidget);
    props.widgetSettupHandler(updatedWidget);
    props.editWidgeToggleModal();
  };

  const renderForm = (isEditMode) => {
    const formKey = isEditMode
      ? `edit-${props.widget?.id ?? "unknown"}`
      : "create";

    return (
      <form
        id="create-widget"
        onSubmit={isEditMode ? handleEditSubmit : handleCreateSubmit}
        key={formKey}
        className="modern-form"
      >
        <div className="form-header">
          <h4>General Settings</h4>
        </div>
        {WidgetSelect()}

        <div className="form-section">
          <div className="form-group">
            <label className="modern-label">Widget Name Font Size</label>
            <input
              name="widget_name_font_size"
              type="number"
              defaultValue={
                isEditMode ? props.widget?.widgetNameFontSize ?? 16 : 16
              }
              min={8}
              max={72}
              className="modern-input modern-number-input"
            />
          </div>
          <hr className="section-divider" />
        </div>

        {settingsVisibility.gauge && (
          <div className="form-section">
            <div className="section-header">
              <h4>Gauge Settings</h4>
            </div>
            <div className="form-grid">
              <div className="form-group">
                <label className="modern-label">Name</label>
                <input
                  name="widget_name"
                  defaultValue={
                    isEditMode ? props.widget?.widget_name ?? "" : ""
                  }
                  className="modern-input"
                />
              </div>
              <div className="form-group">
                <label className="modern-label">Unit</label>
                <input
                  name="widget_unit"
                  defaultValue={
                    isEditMode ? props.widget?.widget_unit ?? "" : ""
                  }
                  className="modern-input"
                />
              </div>
            </div>
          </div>
        )}

        {settingsVisibility.bar_chart && (
          <div className="form-section">
            <div className="section-header">
              <h4>Bar Chart Settings</h4>
            </div>
            <div className="form-grid">
              <div className="form-group">
                <label className="modern-label">Name</label>
                <input
                  name="widget_name"
                  defaultValue={
                    isEditMode ? props.widget?.datasets?.[0]?.name ?? "" : ""
                  }
                  className="modern-input"
                />
              </div>
              <div className="form-group">
                <label className="modern-label">Number of Bars</label>
                <input
                  name="bar_count"
                  type="number"
                  min={1}
                  max={10}
                  onChange={(e) => handleNumberOfBarsChange(e.target.value)}
                  defaultValue={
                    isEditMode ? props.widget?.numberOfBars ?? 5 : 5
                  }
                  className="modern-input modern-number-input"
                />
              </div>
            </div>
            <div className="form-grid color-grid">
              <div className="form-group">
                <label className="modern-label">Bar Background Color</label>
                <input
                  name="bar_bg_color"
                  className="modern-input modern-color-input"
                  type="color"
                  defaultValue={
                    isEditMode
                      ? props.widget?.datasets?.[0]?.bar_bg_color ?? "#000000"
                      : "#000000"
                  }
                />
              </div>
              <div className="form-group">
                <label className="modern-label">Bar Border Color</label>
                <input
                  name="bar_br_color"
                  className="modern-input modern-color-input"
                  type="color"
                  defaultValue={
                    isEditMode
                      ? props.widget?.datasets?.[0]?.bar_br_color ?? "#000000"
                      : "#000000"
                  }
                />
              </div>
            </div>
          </div>
        )}

        {settingsVisibility.realtime_chart && (
          <div className="form-section">
            <div className="section-header">
              <h4>Realtime Chart Settings</h4>
            </div>
            <div className="form-grid">
              <div className="form-group">
                <label className="modern-label">Name</label>
                <input
                  name="widget_name"
                  defaultValue={
                    isEditMode ? props.widget?.widget_name ?? "" : ""
                  }
                  className="modern-input"
                />
              </div>
            </div>
            {renderRealtimeChartInputs(isEditMode)}
          </div>
        )}

        {settingsVisibility.fluid_tank && (
          <div className="form-section">
            <div className="section-header">
              <h4>Fluid Tank Settings</h4>
            </div>
            <div className="form-grid">
              <div className="form-group">
                <label className="modern-label">Name</label>
                <input
                  name="widget_name"
                  defaultValue={
                    isEditMode ? props.widget?.widget_name ?? "" : ""
                  }
                  className="modern-input"
                />
              </div>
              <div className="form-group">
                <label className="modern-label">Lower Limit</label>
                <input
                  name="lower_limit"
                  type="number"
                  defaultValue={
                    isEditMode ? props.widget?.lower_limit ?? "" : ""
                  }
                  className="modern-input modern-number-input"
                />
              </div>
              <div className="form-group">
                <label className="modern-label">Upper Limit</label>
                <input
                  name="upper_limit"
                  type="number"
                  defaultValue={
                    isEditMode ? props.widget?.upper_limit ?? "" : ""
                  }
                  className="modern-input modern-number-input"
                />
              </div>
            </div>
          </div>
        )}

        {settingsVisibility.custom_gauge && (
          <div className="form-section">
            <div className="section-header">
              <h4>Custom Gauge Settings</h4>
            </div>
            <div className="form-grid">
              <div className="form-group">
                <label className="modern-label">Name</label>
                <input
                  name="widget_name"
                  defaultValue={
                    isEditMode ? props.widget?.widget_name ?? "" : ""
                  }
                  className="modern-input"
                />
              </div>
            </div>

            <div className="subsection">
              <h5 className="subsection-title">General</h5>
              <div className="form-grid">
                <div className="form-group">
                  <label className="modern-label">Unit</label>
                  <input
                    name="cg_unit"
                    type="string"
                    defaultValue={
                      isEditMode ? props.widget?.datasets?.[0]?.unit ?? "" : ""
                    }
                    className="modern-input"
                  />
                </div>
                <div className="form-group">
                  <label className="modern-label">Min Value</label>
                  <input
                    name="cg_min_value"
                    type="number"
                    defaultValue={
                      isEditMode
                        ? props.widget?.datasets?.[0]?.minValue ?? 0
                        : 0
                    }
                    className="modern-input modern-number-input"
                  />
                </div>
                <div className="form-group">
                  <label className="modern-label">Max Value</label>
                  <input
                    name="cg_max_value"
                    type="number"
                    defaultValue={
                      isEditMode
                        ? props.widget?.datasets?.[0]?.maxValue ?? 1000
                        : 1000
                    }
                    className="modern-input modern-number-input"
                  />
                </div>
                <div className="form-group">
                  <label className="modern-label">Animation Speed</label>
                  <input
                    name="cg_ani_speed"
                    type="number"
                    defaultValue={
                      isEditMode
                        ? props.widget?.datasets?.[0]?.animationSpeed ?? 32
                        : 32
                    }
                    min={20}
                    max={200}
                    className="modern-input modern-number-input"
                  />
                </div>
              </div>
            </div>

            <div className="subsection">
              <h5 className="subsection-title">Pointer Settings</h5>
              <div className="form-grid">
                <div className="form-group">
                  <label className="modern-label">Pointer Angle</label>
                  <input
                    name="cg_angle"
                    type="text"
                    pattern="^-?\d*\.?\d*$"
                    defaultValue={
                      isEditMode
                        ? props.widget?.datasets?.[0]?.angle ?? -0.03
                        : -0.03
                    }
                    onChange={(e) => {
                      const value = parseFloat(e.target.value);
                      if (isNaN(value)) {
                        e.target.value = isEditMode
                          ? props.widget?.datasets?.[0]?.angle ?? -0.03
                          : -0.03;
                      } else if (value < -1 || value > 1) {
                        e.target.value = Math.max(-1, Math.min(1, value));
                      }
                    }}
                    required
                    title="Please enter a number between -1 and 1 (e.g., -0.03, 0, 1)"
                    className="modern-input modern-number-input"
                  />
                </div>
                <div className="form-group">
                  <label className="modern-label">Pointer Length</label>
                  <input
                    name="cg_pointer_length"
                    type="number"
                    defaultValue={
                      isEditMode
                        ? props.widget?.datasets?.[0]?.pointerLength ?? 0.5
                        : 0.5
                    }
                    min={0.1}
                    max={2}
                    step="0.01"
                    className="modern-input modern-number-input"
                  />
                </div>
                <div className="form-group">
                  <label className="modern-label">Pointer Stroke Width</label>
                  <input
                    name="cg_pointer_sw"
                    type="number"
                    defaultValue={
                      isEditMode
                        ? props.widget?.datasets?.[0]?.pointerStrokeWidth ??
                          0.035
                        : 0.035
                    }
                    min={0.01}
                    max={0.2}
                    step="0.001"
                    className="modern-input modern-number-input"
                  />
                </div>
                <div className="form-group">
                  <label className="modern-label">Pointer Color</label>
                  <input
                    name="cg_pointer_color"
                    type="color"
                    defaultValue={
                      isEditMode
                        ? props.widget?.datasets?.[0]?.pointerColor ?? "#000000"
                        : "#000000"
                    }
                    className="modern-input modern-color-input"
                  />
                </div>
              </div>
            </div>

            <div className="subsection">
              <h5 className="subsection-title">Gauge Appearance</h5>
              <div className="form-grid">
                <div className="form-group">
                  <label className="modern-label">Gauge Width</label>
                  <input
                    name="cg_gauge_width"
                    type="number"
                    defaultValue={
                      isEditMode
                        ? props.widget?.datasets?.[0]?.lineWidth ?? 0.15
                        : 0.15
                    }
                    min={0.1}
                    max={0.4}
                    step="0.001"
                    className="modern-input modern-number-input"
                  />
                </div>
                <div className="form-group">
                  <label className="modern-label">Radius Spread</label>
                  <input
                    name="cg_radius"
                    type="number"
                    defaultValue={
                      isEditMode
                        ? props.widget?.datasets?.[0]?.radiusScale ?? 1
                        : 1
                    }
                    min={1}
                    max={5}
                    step="0.1"
                    className="modern-input modern-number-input"
                  />
                </div>
                <div className="form-group">
                  <label className="modern-label">Start Color</label>
                  <input
                    name="cg_start_color"
                    type="color"
                    defaultValue={
                      isEditMode
                        ? props.widget?.datasets?.[0]?.colorStart ?? "#6F6EA0"
                        : "#6F6EA0"
                    }
                    className="modern-input modern-color-input"
                  />
                </div>
                <div className="form-group">
                  <label className="modern-label">Stop Color</label>
                  <input
                    name="cg_stop_color"
                    type="color"
                    defaultValue={
                      isEditMode
                        ? props.widget?.datasets?.[0]?.colorStop ?? "#C0C0DB"
                        : "#C0C0DB"
                    }
                    className="modern-input modern-color-input"
                  />
                </div>
                <div className="form-group">
                  <label className="modern-label">Stroke Color</label>
                  <input
                    name="cg_stroke_color"
                    type="color"
                    defaultValue={
                      isEditMode
                        ? props.widget?.datasets?.[0]?.strokeColor ?? "#EEEEEE"
                        : "#EEEEEE"
                    }
                    className="modern-input modern-color-input"
                  />
                </div>
              </div>
            </div>

            <div className="subsection">
              <h5 className="subsection-title">Division Settings</h5>
              <div className="form-grid">
                <div className="form-group">
                  <label className="modern-label">Divisions</label>
                  <input
                    name="cg_divisions"
                    type="number"
                    defaultValue={
                      isEditMode
                        ? props.widget?.datasets?.[0]?.divisions ?? 5
                        : 5
                    }
                    min={2}
                    max={20}
                    className="modern-input modern-number-input"
                  />
                </div>
                <div className="form-group">
                  <label className="modern-label">Division Width</label>
                  <input
                    name="cg_dw"
                    type="number"
                    defaultValue={
                      isEditMode
                        ? props.widget?.datasets?.[0]?.divWidth ?? 1.1
                        : 1.1
                    }
                    min={1}
                    max={5}
                    step="0.01"
                    className="modern-input modern-number-input"
                  />
                </div>
                <div className="form-group">
                  <label className="modern-label">Division Length</label>
                  <input
                    name="cg_dl"
                    type="number"
                    defaultValue={
                      isEditMode
                        ? props.widget?.datasets?.[0]?.divLength ?? 0.7
                        : 0.7
                    }
                    min={0.2}
                    max={2}
                    step="0.01"
                    className="modern-input modern-number-input"
                  />
                </div>
                <div className="form-group">
                  <label className="modern-label">Division Color</label>
                  <input
                    name="cg_div_color"
                    type="color"
                    defaultValue={
                      isEditMode
                        ? props.widget?.datasets?.[0]?.divColor ?? "#333333"
                        : "#333333"
                    }
                    className="modern-input modern-color-input"
                  />
                </div>
                <div className="form-group">
                  <label className="modern-label">Sub Divisions</label>
                  <input
                    name="cg_subdivisions"
                    type="number"
                    defaultValue={
                      isEditMode
                        ? props.widget?.datasets?.[0]?.subDivisions ?? 3
                        : 3
                    }
                    min={2}
                    max={10}
                    className="modern-input modern-number-input"
                  />
                </div>
                <div className="form-group">
                  <label className="modern-label">Sub Division Width</label>
                  <input
                    name="cg_sdw"
                    type="number"
                    defaultValue={
                      isEditMode
                        ? props.widget?.datasets?.[0]?.subWidth ?? 0.6
                        : 0.6
                    }
                    min={0.1}
                    max={2}
                    step="0.01"
                    className="modern-input modern-number-input"
                  />
                </div>
                <div className="form-group">
                  <label className="modern-label">Sub Division Length</label>
                  <input
                    name="cg_sdl"
                    type="number"
                    defaultValue={
                      isEditMode
                        ? props.widget?.datasets?.[0]?.subLength ?? 0.5
                        : 0.5
                    }
                    min={0.1}
                    max={2}
                    step="0.01"
                    className="modern-input modern-number-input"
                  />
                </div>
                <div className="form-group">
                  <label className="modern-label">Sub Division Color</label>
                  <input
                    name="cg_subdiv_color"
                    type="color"
                    defaultValue={
                      isEditMode
                        ? props.widget?.datasets?.[0]?.subColor ?? "#666666"
                        : "#666666"
                    }
                    className="modern-input modern-color-input"
                  />
                </div>
              </div>
            </div>

            <div className="subsection">
              <h5 className="subsection-title">Options</h5>
              <div className="checkbox-grid">
                <div className="form-group checkbox-group">
                  <label className="modern-checkbox-label">
                    <input
                      name="cg_limit_max"
                      type="checkbox"
                      defaultChecked={
                        isEditMode
                          ? props.widget?.datasets?.[0]?.limitMax ?? false
                          : false
                      }
                      className="modern-checkbox"
                    />
                    <span className="checkbox-custom"></span>
                    Limit Max Value
                  </label>
                </div>
                <div className="form-group checkbox-group">
                  <label className="modern-checkbox-label">
                    <input
                      name="cg_limit_min"
                      type="checkbox"
                      defaultChecked={
                        isEditMode
                          ? props.widget?.datasets?.[0]?.limitMin ?? false
                          : false
                      }
                      className="modern-checkbox"
                    />
                    <span className="checkbox-custom"></span>
                    Limit Min Value
                  </label>
                </div>
                <div className="form-group checkbox-group">
                  <label className="modern-checkbox-label">
                    <input
                      name="cg_gradient"
                      type="checkbox"
                      defaultChecked={
                        isEditMode
                          ? props.widget?.datasets?.[0]?.generateGradient ??
                            false
                          : false
                      }
                      className="modern-checkbox"
                    />
                    <span className="checkbox-custom"></span>
                    Gradient Effect
                  </label>
                </div>
                <div className="form-group checkbox-group">
                  <label className="modern-checkbox-label">
                    <input
                      name="cg_donut"
                      type="checkbox"
                      defaultChecked={
                        isEditMode
                          ? props.widget?.datasets?.[0]?.donut ?? false
                          : false
                      }
                      className="modern-checkbox"
                    />
                    <span className="checkbox-custom"></span>
                    Donut Shape
                  </label>
                </div>
              </div>
            </div>
          </div>
        )}

        {settingsVisibility.equilizer_bar && (
          <div className="form-section">
            <div className="section-header">
              <h4>Multi Source Bar Chart Settings</h4>
            </div>
            <div className="form-grid">
              <div className="form-group">
                <label className="modern-label">Name</label>
                <input
                  name="widget_name"
                  defaultValue={
                    isEditMode ? props.widget?.datasets?.[0]?.name ?? "" : ""
                  }
                  className="modern-input"
                />
              </div>
              <div className="form-group">
                <label className="modern-label">Number Of Sources</label>
                <input
                  name="eb_src_cnt"
                  type="number"
                  min={1}
                  max={5}
                  onChange={(e) => handleSourceCountChange(e.target.value)}
                  defaultValue={
                    isEditMode ? props.widget?.datasets?.[0]?.sourceCnt ?? 1 : 1
                  }
                  className="modern-input modern-number-input"
                />
              </div>
            </div>
            {renderSourceColorInputs(sourceCount)}
          </div>
        )}

        {settingsVisibility.mqtt_writer && (
          <div className="form-section">
            <div className="section-header">
              <h4>MQTT Writer Settings</h4>
            </div>
            <div className="form-grid">
              <div className="form-group">
                <label className="modern-label">Name</label>
                <input
                  name="widget_name"
                  defaultValue={
                    isEditMode ? props.widget?.widget_name ?? "" : ""
                  }
                  className="modern-input"
                />
              </div>
              <div className="form-group">
                <label className="modern-label">MQTT Server</label>
                <input
                  type="text"
                  required
                  name="mw_server"
                  placeholder="MQTT Server"
                  defaultValue={
                    isEditMode ? props.widget?.datasets?.[0]?.host ?? "" : ""
                  }
                  className="modern-input"
                />
              </div>
              <div className="form-group">
                <label className="modern-label">Port</label>
                <input
                  type="number"
                  required
                  name="mw_port"
                  placeholder="Port"
                  defaultValue={
                    isEditMode
                      ? props.widget?.datasets?.[0]?.port ?? 1883
                      : 1883
                  }
                  className="modern-input modern-number-input"
                />
              </div>
              <div className="form-group">
                <label className="modern-label">Topic</label>
                <input
                  type="text"
                  required
                  name="mw_topic"
                  placeholder="Topic"
                  defaultValue={
                    isEditMode ? props.widget?.datasets?.[0]?.topic ?? "" : ""
                  }
                  className="modern-input"
                />
              </div>
              <div className="form-group">
                <label className="modern-label">Username</label>
                <input
                  type="text"
                  name="mw_username"
                  placeholder="Username (optional)"
                  defaultValue={
                    isEditMode
                      ? props.widget?.datasets?.[0]?.username ?? ""
                      : ""
                  }
                  className="modern-input"
                />
              </div>
              <div className="form-group">
                <label className="modern-label">Password</label>
                <input
                  type="password"
                  name="mw_password"
                  placeholder="Password (optional)"
                  defaultValue={
                    isEditMode
                      ? props.widget?.datasets?.[0]?.password ?? ""
                      : ""
                  }
                  className="modern-input"
                />
              </div>
              <div className="form-group">
                <label className="modern-label">Client ID</label>
                <input
                  type="text"
                  name="mw_clientId"
                  placeholder="Client ID (optional)"
                  defaultValue={
                    isEditMode
                      ? props.widget?.datasets?.[0]?.clientId ?? ""
                      : ""
                  }
                  className="modern-input"
                />
              </div>
            </div>
          </div>
        )}

        {settingsVisibility.mqtt_indicator && (
          <div className="form-section">
            <div className="section-header">
              <h4>Indicator Light Settings</h4>
            </div>
            <div className="form-grid">
              <div className="form-group">
                <label className="modern-label">Name</label>
                <input
                  name="widget_name"
                  defaultValue={
                    isEditMode ? props.widget?.datasets?.[0]?.title ?? "" : ""
                  }
                  className="modern-input"
                />
              </div>
              <div className="form-group">
                <label className="modern-label">Off Text</label>
                <input
                  name="mi_off_text"
                  defaultValue={
                    isEditMode ? props.widget?.datasets?.[0]?.offText ?? "" : ""
                  }
                  className="modern-input"
                />
              </div>
              <div className="form-group">
                <label className="modern-label">On Text</label>
                <input
                  name="mi_on_text"
                  defaultValue={
                    isEditMode ? props.widget?.datasets?.[0]?.onText ?? "" : ""
                  }
                  className="modern-input"
                />
              </div>
              <div className="form-group">
                <label className="modern-label">Refresh Interval (ms)</label>
                <input
                  name="mi_refresh"
                  type="number"
                  min={100}
                  defaultValue={
                    isEditMode
                      ? props.widget?.datasets?.[0]?.refreshInterval ?? 2000
                      : 2000
                  }
                  className="modern-input modern-number-input"
                />
              </div>
            </div>
          </div>
        )}

        {settingsVisibility.realtime_table && (
          <div className="form-section">
            <div className="section-header">
              <h4>Realtime Table Settings</h4>
            </div>
            <div className="form-grid">
              <div className="form-group">
                <label className="modern-label">Name</label>
                <input
                  name="widget_name"
                  defaultValue={isEditMode ? props.widget?.tableName ?? "" : ""}
                  className="modern-input"
                />
              </div>
              <div className="form-group">
                <label className="modern-label">Number Of Columns</label>
                <input
                  name="rt_noc"
                  type="number"
                  min={1}
                  max={10}
                  onChange={(e) => handleNumberOfColumns(e.target.value)}
                  defaultValue={isEditMode ? props.widget?.columns ?? 1 : 1}
                  className="modern-input modern-number-input"
                />
              </div>
            </div>
            {renderLabelValue(numberOfColumn)}
            <div className="form-grid">
              <div className="form-group">
                <label className="modern-label">Max Rows</label>
                <input
                  name="maxRows"
                  type="number"
                  min={1}
                  defaultValue={
                    isEditMode
                      ? props.widget?.widgetProperty?.maxRows ?? 100
                      : 100
                  }
                  className="modern-input modern-number-input"
                />
              </div>
              <div className="form-group">
                <label className="modern-label">Max Rows Per Page</label>
                <input
                  name="maxRowsPerPage"
                  type="number"
                  min={1}
                  defaultValue={
                    isEditMode
                      ? props.widget?.widgetProperty?.maxRowsPerPage ?? 10
                      : 10
                  }
                  className="modern-input modern-number-input"
                />
              </div>
              <div className="form-group checkbox-group">
                <label className="modern-checkbox-label">
                  <input
                    name="showTimeColumn"
                    type="checkbox"
                    defaultChecked={
                      isEditMode
                        ? props.widget?.widgetProperty?.showTimeColumn ?? false
                        : false
                    }
                    className="modern-checkbox"
                  />
                  <span className="checkbox-custom"></span>
                  Show Time Column
                </label>
              </div>
              <div className="form-group">
                <label className="modern-label">Update Interval (ms)</label>
                <input
                  name="updateInterval"
                  type="number"
                  min={100}
                  defaultValue={
                    isEditMode
                      ? props.widget?.widgetProperty?.updateInterval ?? 2000
                      : 2000
                  }
                  className="modern-input modern-number-input"
                />
              </div>
              <div className="form-group">
                <label className="modern-label">Background Color</label>
                <input
                  name="backgroundColor"
                  type="color"
                  defaultValue={
                    isEditMode
                      ? props.widget?.widgetProperty?.backgroundColor ??
                        "#ffffff"
                      : "#ffffff"
                  }
                  className="modern-input modern-color-input"
                />
              </div>
              <div className="form-group">
                <label className="modern-label">Text Color</label>
                <input
                  name="textColor"
                  type="color"
                  defaultValue={
                    isEditMode
                      ? props.widget?.widgetProperty?.textColor ?? "#000000"
                      : "#000000"
                  }
                  className="modern-input modern-color-input"
                />
              </div>
              <div className="form-group">
                <label className="modern-label">Font Size (px)</label>
                <input
                  name="fontSize"
                  type="number"
                  min={8}
                  defaultValue={
                    isEditMode
                      ? parseInt(props.widget?.widgetProperty?.fontSize) || 14
                      : 14
                  }
                  className="modern-input modern-number-input"
                />
              </div>
              <div className="form-group">
                <label className="modern-label">Border Color</label>
                <input
                  name="borderColor"
                  type="color"
                  defaultValue={
                    isEditMode
                      ? props.widget?.widgetProperty?.borderColor ?? "#ccc"
                      : "#ccc"
                  }
                  className="modern-input modern-color-input"
                />
              </div>
            </div>
          </div>
        )}

        {settingsVisibility.text_widget && (
          <div className="form-section">
            <div className="section-header">
              <h4>Text Widget Settings</h4>
            </div>
            <div className="form-grid">
              <div className="form-group">
                <label className="modern-label">Name</label>
                <input
                  name="widget_name"
                  defaultValue={
                    isEditMode ? props.widget?.widget_name ?? "" : ""
                  }
                  className="modern-input"
                />
              </div>
              <div className="form-group">
                <label className="modern-label">Text Content</label>
                <input
                  name="text_content"
                  defaultValue={
                    isEditMode ? props.widget?.datasets?.[0]?.text ?? "" : ""
                  }
                  className="modern-input"
                />
              </div>
              <div className="form-group">
                <label className="modern-label">Font Size</label>
                <input
                  name="text_font_size"
                  type="number"
                  min={8}
                  defaultValue={
                    isEditMode
                      ? props.widget?.datasets?.[0]?.fontSize ?? 16
                      : 16
                  }
                  className="modern-input modern-number-input"
                />
              </div>
              <div className="form-group">
                <label className="modern-label">Font Weight</label>
                <input
                  name="text_font_weight"
                  type="number"
                  min={100}
                  max={900}
                  step={100}
                  defaultValue={
                    isEditMode
                      ? props.widget?.datasets?.[0]?.fontWeight ?? 300
                      : 300
                  }
                  className="modern-input modern-number-input"
                />
              </div>
              <div className="form-group">
                <label className="modern-label">Text Color</label>
                <input
                  name="text_color"
                  type="color"
                  defaultValue={
                    isEditMode
                      ? props.widget?.datasets?.[0]?.textColor ?? "#ffffffff"
                      : "#ffffffff"
                  }
                  className="modern-input modern-color-input"
                />
              </div>
              <div className="form-group">
                <label className="modern-label">Background Color</label>
                <input
                  name="text_background_color"
                  type="color"
                  defaultValue={
                    isEditMode
                      ? props.widget?.datasets?.[0]?.backgroundColor ??
                        "#28282b"
                      : "#28282b"
                  }
                  className="modern-input modern-color-input"
                />
              </div>
            </div>
          </div>
        )}

        {settingsVisibility.dynamic_text_widget && (
          <div className="form-section">
            <div className="section-header">
              <h4>Dynamic Text Widget Settings</h4>
            </div>
            <div className="form-group">
              <label className="modern-label">Name</label>
              <input
                name="widget_name"
                defaultValue={isEditMode ? props.widget?.widget_name ?? "" : ""}
                required
                className="modern-input"
              />
            </div>
            <div className="form-group">
              <label className="modern-label">Logic Input</label>
              <textarea
                name="logic_input"
                rows={5}
                defaultValue={
                  isEditMode
                    ? props.widget?.datasets?.[0]?.logicInput ?? ""
                    : ""
                }
                placeholder={
                  "// Use 'status' variable to access the fetched value and 'mapping' to access status pairs.\n" +
                  "// Example 1: return mapping[status] || 'Unknown';\n" +
                  "// Example 2: return status == '1' ? 'On' : 'Off';"
                }
                className="modern-textarea"
              />
            </div>
            <div className="form-grid">
              <div className="form-group">
                <label className="modern-label">Font/icon Size</label>
                <input
                  name="dynamic_text_widget_font_size"
                  type="number"
                  min={8}
                  defaultValue={
                    isEditMode
                      ? props.widget?.datasets?.[0]?.fontSize ?? 16
                      : 16
                  }
                  className="modern-input modern-number-input"
                />
              </div>
              <div className="form-group">
                <label className="modern-label">Font Weight</label>
                <input
                  name="dynamic_text_widget_font_weight"
                  type="number"
                  min={100}
                  max={900}
                  step={100}
                  defaultValue={
                    isEditMode
                      ? props.widget?.datasets?.[0]?.fontWeight ?? 300
                      : 300
                  }
                  className="modern-input modern-number-input"
                />
              </div>
              <div className="form-group">
                <label className="modern-label">Number of Statuses</label>
                <input
                  name="number_of_statuses"
                  type="number"
                  min={0}
                  max={100}
                  onChange={handleNumberOfStatusesChange}
                  defaultValue={isEditMode ? numberOfStatuses : 0}
                  className="modern-input modern-number-input"
                />
              </div>
            </div>
            {renderStatusInputs()}
          </div>
        )}

        {settingsVisibility.editable_table_widget && (
          <div className="form-section">
            <div className="section-header">
              <h4>Editable Form Widget Settings</h4>
            </div>
            <div className="form-grid">
              <div className="form-group">
                <label className="modern-label">Topic</label>
                <input
                  type="text"
                  required
                  name="mw_topic"
                  placeholder="Topic"
                  defaultValue={
                    isEditMode ? props.widget?.datasets?.[0]?.topic ?? "" : ""
                  }
                  className="modern-input"
                />
              </div>
              <div className="form-group">
                <label className="modern-label">MQTT Server</label>
                <input
                  type="text"
                  required
                  name="mw_server"
                  placeholder="MQTT Server"
                  defaultValue={
                    isEditMode ? props.widget?.datasets?.[0]?.host ?? "" : ""
                  }
                  className="modern-input"
                />
              </div>
              <div className="form-group">
                <label className="modern-label">Port</label>
                <input
                  type="number"
                  required
                  name="mw_port"
                  placeholder="Port"
                  defaultValue={
                    isEditMode
                      ? props.widget?.datasets?.[0]?.port ?? 1883
                      : 1883
                  }
                  className="modern-input modern-number-input"
                />
              </div>
              <div className="form-group">
                <label className="modern-label">Name</label>
                <input
                  name="widget_name"
                  defaultValue={
                    isEditMode ? props.widget?.datasets?.[0]?.name ?? "" : ""
                  }
                  className="modern-input"
                />
              </div>
              <div className="form-group">
                <label className="modern-label">Number of Input Fields</label>
                <input
                  name="number_of_input_fields"
                  type="number"
                  min={0}
                  max={100}
                  onChange={handleNumberOfInputFields}
                  defaultValue={
                    isEditMode
                      ? props.widget?.datasets?.[0]?.numberOfInputFields ?? 0
                      : 0
                  }
                  className="modern-input modern-number-input"
                />
              </div>

              <div className="form-group checkbox-group">
                <label className="modern-label checkbox-label">
                  <input
                    type="checkbox"
                    name="enable_extra_dropdown"
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setEnableDropdown(checked);

                      setCustomFormInputFields((prev) => {
                        const updated = { ...prev };
                        const extraIndex = numberOfInputFields;

                        if (checked) {
                          // ✅ Only add if not already present
                          if (!(extraIndex in updated)) {
                            updated[`form_input_field_${extraIndex}`] =
                              "Machine ID";
                          }
                        } else {
                          // ✅ Remove if unchecked
                          delete updated[`form_input_field_${extraIndex}`];
                        }

                        return updated;
                      });
                    }}
                    defaultChecked={
                      isEditMode
                        ? props.widget?.datasets?.[0]?.enableExtraDropdown ??
                          false
                        : false
                    }
                    className="modern-checkbox-editable-table"
                  />
                  <span className="checkbox-text">Enable Extra Dropdown</span>
                </label>
              </div>
            </div>
            {renderCustomFormInputFields()}
            <hr style={{ color: "black" }}></hr>

            {enableDropdown && (
              <div className="form-grid">
                <div className="form-group">
                  <label className="modern-label">Add Options</label>

                  {/* Add new option */}
                  <div
                    style={{ display: "flex", gap: "8px", marginBottom: "8px" }}
                  >
                    <input
                      type="text"
                      value={newOption}
                      onChange={(e) => setNewOption(e.target.value)}
                      placeholder="Enter value"
                      className="modern-input"
                    />
                    <button
                      type="button"
                      onClick={() => {
                        if (
                          newOption.trim() &&
                          !extraOptions.includes(newOption.trim())
                        ) {
                          setExtraOptions((prev) => [
                            ...prev,
                            newOption.trim(),
                          ]);
                          setNewOption("");
                        }
                      }}
                      className="modern-primary-button"
                      style={{
                        border: "none",
                        padding: "8px 20px",
                        borderRadius: "1rem",
                      }}
                    >
                      Add
                    </button>
                  </div>

                  {/* Display added options with remove button */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "4px",
                    }}
                  >
                    {extraOptions.map((opt, idx) => (
                      <div
                        key={idx}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          padding: "4px 8px",
                          background: "#dcdcdcff",
                          borderRadius: "4px",
                          color: "black",
                        }}
                      >
                        <span>{opt}</span>
                        <button
                          type="button"
                          style={{
                            marginLeft: "auto",
                            padding: "2px 6px",
                            background: "#e74c3c",
                            color: "#000000ff",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            setExtraOptions((prev) =>
                              prev.filter((o) => o !== opt)
                            )
                          }
                        >
                          Remove
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {settingsVisibility.access_list_widget && (
          <div className="form-section">
            <div className="section-header">
              <h4>Access List Widget Settings</h4>
            </div>
            <div className="form-group">
              <label className="modern-label">Name</label>
              <input
                name="widget_name"
                defaultValue={
                  isEditMode ? props.widget?.datasets?.[0]?.name ?? "" : ""
                }
                className="modern-input"
              />
            </div>
          </div>
        )}

        {settingsVisibility.push_button && (
          <div className="form-section">
            <div className="section-header">
              <h4>Push Button Settings</h4>
            </div>
            <div className="form-grid">
              <div className="form-group">
                <label className="modern-label">Topic</label>
                <input
                  type="text"
                  required
                  name="mw_topic"
                  placeholder="Topic"
                  defaultValue={
                    isEditMode ? props.widget?.datasets?.[0]?.topic ?? "" : ""
                  }
                  className="modern-input"
                />
              </div>
              <div className="form-group">
                <label className="modern-label">MQTT Server</label>
                <input
                  type="text"
                  required
                  name="mw_server"
                  placeholder="MQTT Server"
                  defaultValue={
                    isEditMode ? props.widget?.datasets?.[0]?.host ?? "" : ""
                  }
                  className="modern-input"
                />
              </div>
              <div className="form-group">
                <label className="modern-label">Port</label>
                <input
                  type="number"
                  required
                  name="mw_port"
                  placeholder="Port"
                  defaultValue={
                    isEditMode
                      ? props.widget?.datasets?.[0]?.port ?? 1883
                      : 1883
                  }
                  className="modern-input modern-number-input"
                />
              </div>
              <div className="form-group">
                <label className="modern-label">Off Text</label>
                <input
                  name="mi_off_text"
                  defaultValue={
                    isEditMode
                      ? props.widget?.datasets?.[0]?.payload_off ?? ""
                      : ""
                  }
                  className="modern-input"
                />
              </div>
              <div className="form-group">
                <label className="modern-label">On Text</label>
                <input
                  name="mi_on_text"
                  defaultValue={
                    isEditMode
                      ? props.widget?.datasets?.[0]?.payload_on ?? ""
                      : ""
                  }
                  className="modern-input"
                />
              </div>
              <div className="form-group">
                <label className="modern-label">Name</label>
                <input
                  name="widget_name"
                  defaultValue={
                    isEditMode ? props.widget?.datasets?.[0]?.name ?? "" : ""
                  }
                  className="modern-input"
                />
              </div>
            </div>
          </div>
        )}

        {settingsVisibility.switch_button && (
          <div className="form-section">
            <div className="section-header">
              <h4>Switch Button Settings</h4>
            </div>
            <div className="form-grid">
              <div className="form-group">
                <label className="modern-label">Topic</label>
                <input
                  type="text"
                  required
                  name="mw_topic"
                  placeholder="Topic"
                  defaultValue={
                    isEditMode ? props.widget?.datasets?.[0]?.topic ?? "" : ""
                  }
                  className="modern-input"
                />
              </div>
              <div className="form-group">
                <label className="modern-label">MQTT Server</label>
                <input
                  type="text"
                  required
                  name="mw_server"
                  placeholder="MQTT Server"
                  defaultValue={
                    isEditMode ? props.widget?.datasets?.[0]?.host ?? "" : ""
                  }
                  className="modern-input"
                />
              </div>
              <div className="form-group">
                <label className="modern-label">Port</label>
                <input
                  type="number"
                  required
                  name="mw_port"
                  placeholder="Port"
                  defaultValue={
                    isEditMode
                      ? props.widget?.datasets?.[0]?.port ?? 1883
                      : 1883
                  }
                  className="modern-input modern-number-input"
                />
              </div>
              <div className="form-group">
                <label className="modern-label">Off Text</label>
                <input
                  name="mi_off_text"
                  defaultValue={
                    isEditMode
                      ? props.widget?.datasets?.[0]?.payload_off ?? ""
                      : ""
                  }
                  className="modern-input"
                />
              </div>
              <div className="form-group">
                <label className="modern-label">On Text</label>
                <input
                  name="mi_on_text"
                  defaultValue={
                    isEditMode
                      ? props.widget?.datasets?.[0]?.payload_on ?? ""
                      : ""
                  }
                  className="modern-input"
                />
              </div>
              <div className="form-group">
                <label className="modern-label">Name</label>
                <input
                  name="widget_name"
                  defaultValue={
                    isEditMode ? props.widget?.datasets?.[0]?.name ?? "" : ""
                  }
                  className="modern-input"
                />
              </div>
            </div>
          </div>
        )}

        {settingsVisibility.map_widget && (
          <div className="form-section">
            <div className="section-header">
              <h4>Map Widget Settings</h4>
            </div>
            <div className="form-group">
              <label className="modern-label">Widget Name</label>
              <input
                type="text"
                required
                name="mw_name"
                placeholder="Widget Name"
                defaultValue={
                  isEditMode ? props.widget?.datasets?.[0]?.name ?? "" : ""
                }
                className="modern-input"
              />
            </div>
            <div className="form-group">
                <label className="modern-label">Number Of Device</label>
                <input
                  name="mw_device_cnt"
                  type="number"
                  min={1}
                  max={10}
                  onChange={(e) => handleDeviceSourceCountChange(e.target.value)}
                  defaultValue={
                    isEditMode ? props.widget?.datasets?.[0]?.sourceCnt ?? 1 : 1
                  }
                  className="modern-input modern-number-input"
                />
              </div>

            <div className="form-group">
              <label className="modern-label">
                Default Center (Latitude, Longitude)
              </label>
              <input
                type="text"
                required
                name="mw_center"
                placeholder="e.g., 28.6139, 77.2090"
                defaultValue={
                  isEditMode ? props.widget?.datasets?.[0]?.center : ""
                }
                className="modern-input"
              />
            </div>
            <div className="form-group">
              <label className="modern-label">Zoom Level</label>
              <input
                type="number"
                min={1}
                max={20}
                name="mw_zoom"
                placeholder="Zoom Level"
                defaultValue={
                  isEditMode ? props.widget?.datasets?.[0]?.zoom ?? 10 : 10
                }
                className="modern-input modern-number-input"
              />
            </div>
            <div className="form-group checkbox-group">
              <label className="modern-checkbox-label">
                <input
                  type="checkbox"
                  name="mw_geofence_enable"
                  defaultChecked={
                    isEditMode
                      ? props.widget?.datasets?.[0]?.geofence?.enabled ?? false
                      : false
                  }
                  className="modern-checkbox"
                />
                <span className="checkbox-custom"></span>
                Enable Geofencing
              </label>
            </div>
            <div className="form-group">
              <label className="modern-label">Geofence Type</label>
              <select
                name="mw_geofence_type"
                value={geofenceType}
                onChange={(e) => setGeofenceType(e.target.value)}
                className="modern-select"
              >
                <option value="circle">Circle</option>
                <option value="polygon">Polygon</option>
                <option value="rectangle">Rectangle</option>
              </select>
            </div>

            {geofenceType === "circle" && (
              <div className="form-group">
                <label className="modern-label">Geofence Radius (meters)</label>
                <input
                  type="number"
                  name="mw_geofence_radius"
                  defaultValue={
                    isEditMode
                      ? props.widget?.datasets?.[0]?.geofence?.radius ?? 100
                      : 100
                  }
                  className="modern-input modern-number-input"
                />
              </div>
            )}

            {(geofenceType === "polygon" || geofenceType === "rectangle") && (
              <div className="form-group">
                <label className="modern-label">Geofence Coordinates</label>
                <textarea
                  name="mw_geofence_coordinates"
                  placeholder="Enter coordinates as [[lat,lng],[lat,lng],...]"
                  defaultValue={
                    isEditMode
                      ? JSON.stringify(
                          props.widget?.datasets?.[0]?.geofence?.coordinates ||
                            []
                        )
                      : "[]"
                  }
                  className="modern-textarea"
                />
              </div>
            )}

            <div className="form-group checkbox-group">
              <label className="modern-checkbox-label">
                <input
                  type="checkbox"
                  name="mw_markers_enable"
                  defaultChecked={
                    isEditMode
                      ? props.widget?.datasets?.[0]?.markers?.enabled ?? false
                      : false
                  }
                  className="modern-checkbox"
                />
                <span className="checkbox-custom"></span>
                Show Markers
              </label>
            </div>

            <div className="form-group">
              <label className="modern-label">
                Data Refresh Interval (seconds)
              </label>
              <input
                type="number"
                name="mw_refresh_interval"
                min={1}
                defaultValue={
                  isEditMode
                    ? props.widget?.datasets?.[0]?.refreshInterval ?? 10
                    : 10
                }
                className="modern-input modern-number-input"
              />
            </div>
          </div>
        )}

        {settingsVisibility.nested_pane && (
          <div className="form-section">
            <div className="section-header">
              <h4>Nested Pane Settings</h4>
            </div>
            <div className="form-group">
              <label className="modern-label">Name</label>
              <input
                name="widget_name"
                defaultValue={isEditMode ? props.widget?.widget_name ?? "" : ""}
                className="modern-input"
              />
            </div>
          </div>
        )}

        {settingsVisibility.image_widget && (
          <div className="form-section">
            <div className="section-header">
              <h4>Image Widget Settings</h4>
            </div>
            <div className="form-grid">
              <div className="form-group">
                <label className="modern-label">Name</label>
                <input
                  name="widget_name"
                  defaultValue={
                    isEditMode ? props.widget?.widget_name ?? "" : ""
                  }
                  className="modern-input"
                />
              </div>
              <div className="form-group">
                <label className="modern-label">Upload Image</label>
                <input
                  type="file"
                  name="image_upload"
                  accept="image/*"
                  onChange={handleImageUpload}
                  className="modern-file-input"
                />
              </div>
            </div>
            {imageFile && (
              <div className="form-group">
                <div className="image-preview-container">
                  <img
                    src={imageFile}
                    alt="Preview"
                    className="modern-image-preview"
                  />
                </div>
              </div>
            )}
          </div>
        )}

        <div className="form-actions">
          <button type="submit" className="modern-button modern-primary-button">
            {isEditMode ? "Update Widget" : "Add Widget"}
          </button>
        </div>
      </form>
    );
  };


  return (
    <div className="modern-modal-overlay">
      {props.editWidgetModal ? (
        <>
          <div
            onClick={props.editWidgeToggleModal}
            className="modern-overlay"
          ></div>
          <div className="modern-modal-content">
            <div className="modern-modal-header">
              <button
                className="modern-close-button"
                onClick={props.editWidgeToggleModal}
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
            <div className="modern-form-container">{renderForm(true)}</div>
          </div>
        </>
      ) : (
        <>
          <div onClick={props.toggleModal} className="modern-overlay"></div>
          <div className="modern-modal-content">
            <div className="modern-modal-header">
              <button
                className="modern-close-button"
                onClick={props.toggleModal}
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
            <div className="modern-form-container">{renderForm(false)}</div>
          </div>
        </>
      )}
    </div>
  );
}

DropDownModal.propTypes = {
  toggleModal: PropTypes.func,
  editWidgeToggleModal: PropTypes.func,
  editWidgetModal: PropTypes.bool,
  widgetSettupHandler: PropTypes.func.isRequired,
  onChangeWidget: PropTypes.func,
  paneArray: PropTypes.array,
  setPaneArray: PropTypes.func,
  widget: PropTypes.object,
  currentPaneIndex: PropTypes.number,
  currentWidgetIndex: PropTypes.number,
  currentNestedWidgetIndex: PropTypes.number,
};

export default DropDownModal;
